import { isReferralOut } from '../../../utils/isReferralOut'
import React, { useEffect, useRef, useState } from 'react'
import {
  FaCartPlus,
  FaList,
  FaListUl,
  FaPlus,
  FaShoppingCart,
  FaStar,
  FaRegStar,
  FaCheckCircle,
  FaExclamationTriangle,
  FaTimesCircle
} from 'react-icons/fa'
import ConfirmationModal from '../../../shared/ConfirmationModal'
import CardHeading from '../../../shared/CardHeading'
import CustomButton from '../../../shared/CustomButton'
import {
  body_siteitems,
  careTeamsOptions,
  dentalItems,
  dentalSubSites,
  diagnosisOptions,
  frequencyOptionss,
  itemstableColumns,
  medSelectionReasons,
  routeOptions,
  subSites,
  supportingInfoOptions
} from '../../../constants/EmrContants'
import ReusableModal from '../../../shared/ReuseableModal'
import CustomTable from '../../../shared/CustomTable'
import AutoCompleteField from '../../../shared/AutoCompleteField'
import { Field, FieldArray, Form, Formik, useFormikContext } from 'formik'
import DropdownField from '../../../shared/DropdownField'
import TextInput from '../../../shared/TextInput'
import DatePicker from '../../../shared/DatePicker'
import {
  priceListTypesOptionsFormatForOrderItems,
  standardCodeOptions
} from '../../../constants/PriceListConstants'
import { fetchData } from '../../../helpers/fetchData'
import * as Yup from 'yup'
import { DeleteIcon, EditIcon } from '../../../utils/TableActionIcons'
import CustomChip from '../../../shared/CustomChip'
import MultiSelectField from '../../../shared/MultiSelectField'
import CheckPermission from '../../../hooks/CheckPermission'
import SearchPriceListField from '../../../shared/SearchPriceListField'
import {
  approvalStatusOptions,
  searchedPriceItemsOptionsFormat,
  searchedPriceItemsOptionsFormatSFDA
} from '../../../constants/VisitsConstants'
import { useSelector } from 'react-redux'
import { getRouteAndFrequencyData } from '../../../services/ApiMethods'
import { useTranslation } from 'react-i18next'
import {
  isDisableEmrUnitPrice,
  isHideEmrDiscount,
  isHideEmrUnitPrice
} from '../../../utils/businessLevelAccess'
import { FaFlask, FaTooth, FaPills, FaTools, FaTags } from 'react-icons/fa'
import { MdMiscellaneousServices, MdOutlineAdd } from 'react-icons/md'
import { GiHealthNormal } from 'react-icons/gi'
import toast from 'react-hot-toast'
import CDSSReport from './CDSSReport'
import useFetchData from '../../../hooks/UseFetchData'
import SwitchInput from '../../../shared/SwitchInput'
import HeartIcon from '../../../shared/HeartIcon'
import NoDataFound from '../../../shared/NoDataFound'
import Spinner from '../../../shared/Spinner'
import { levenshtein } from '../../../utils/CompareItems'
import SfdaPriceList from '../../../shared/SfdaPriceList'
import { CalculateAgeInYears } from '../../../utils/CalculateAge'
import DentalSelctedTooth from '../../../shared/DentalSelctedTooth'
import {
  getItemStockCode,
  getOutOfStockMessage,
  isOutOfStockItem,
  isQuantityOverStock,
  showStockLimitToast
} from '../../../utils/StockAlerts'

export const getPriceListIcon = (typeName, isVisit = false) => {
  switch (typeName?.toLowerCase()) {
    case 'services':
      return (
        <MdMiscellaneousServices
          className='text-gray-500'
          size={isVisit ? 14 : 16}
        />
      )
    case 'oral-health-op':
    case 'dental':
      return <FaTooth className='text-gray-500' size={isVisit ? 14 : 16} />
    case 'laboratory':
      return <FaFlask className='text-gray-500' size={isVisit ? 14 : 16} />
    case 'procedures':
      return <FaTools className='text-gray-500' size={isVisit ? 14 : 16} />
    case 'medication-codes':
      return <FaPills className='text-gray-500' size={isVisit ? 14 : 16} />
    case 'test 101 price':
      return <FaTags className='text-gray-500' size={isVisit ? 14 : 16} />
    case 'new sub type':
    case 'test new sub type':
      return (
        <GiHealthNormal className='text-gray-500' size={isVisit ? 14 : 16} />
      )
    default:
      return <FaListUl className='text-gray-500' size={isVisit ? 14 : 16} />
  }
}

const sfdaCoverageStatus = t => ({
  generic: {
    label: t('Covered'),
    icon: <FaCheckCircle className='text-green-600' size={14} />,
    color: 'text-green-600'
  },
  'brand replacable': {
    label: t('Covered (generic preferred)'),
    icon: <FaCheckCircle className='text-green-600' size={14} />,
    color: 'text-green-600'
  },
  nce: {
    label: t('Covered (generic)'),
    icon: <FaCheckCircle className='text-green-600' size={14} />,
    color: 'text-green-600'
  },
  biological: {
    label: t('Strict approval'),
    icon: <FaExclamationTriangle className='text-yellow-600' size={14} />,
    color: 'text-yellow-600'
  },
  'medical device': {
    label: t('Depends'),
    icon: <FaExclamationTriangle className='text-yellow-600' size={14} />,
    color: 'text-yellow-600'
  },
  radiopharmaceutical: {
    label: t('Special cases'),
    icon: <FaExclamationTriangle className='text-yellow-600' size={14} />,
    color: 'text-yellow-600'
  },
  milk: {
    label: t('Not covered'),
    icon: <FaTimesCircle className='text-red-600' size={14} />,
    color: 'text-red-600'
  }
})

const TableHeader = [
  'Actions',
  'Itm Type',
  'Itm Ctg',
  'Item',

  'Body Site',
  'U.Price',
  'Qty',
  'Disc',
  'Net Price',
  'Days Supply',
  'Route',
  'Frequency',
  'Dose',
  'Apv Req',
  'Apv No'
]

const LOCAL_PHARMACY_PROVIDER_CODE = 'local-business-pharmacy'
const ITEM_SOURCE_PRICELIST = 'pricelist'
const ITEM_SOURCE_SFDA = 'sfda'
const ITEM_SOURCE_PROVIDER_PHARMACY = 'provider_pharmacy'

const roundToTwo = value => Math.round((Number(value) || 0) * 100) / 100

const recalculateItemShares = (item, options = {}) => {
  const { isSaudiPatient = false, vatRate = 0.15 } = options
  const isCash = String(item?.item_category || '').toLowerCase() === 'cash'
  const quantity = Number(item?.quantity) || 1
  const unitPrice = Number(item?.unit_price) || 0
  const factor = Number(item?.factor) || 1
  const grossAmount = unitPrice * quantity * factor
  const discountValue = Number(item?.discount_amount) || 0
  const discountAmount =
    item?.discount_type === 'fixed'
      ? discountValue
      : (grossAmount * discountValue) / 100
  const netPayableAmount = Math.max(grossAmount - discountAmount, 0)
  const patientSharePercent = isCash ? 100 : Number(item?.patient_share) || 0
  const patientShareAmount = (netPayableAmount * patientSharePercent) / 100
  const companyShare = Math.max(netPayableAmount - patientShareAmount, 0)
  const patientTaxAmount =
    item?.tax_check && !isSaudiPatient ? patientShareAmount * vatRate : 0
  const companyTaxAmount =
    companyShare > 0 && (item?.payer_vat || !isSaudiPatient)
      ? companyShare * vatRate
      : 0
  const patientShareWithVat = roundToTwo(patientShareAmount + patientTaxAmount)
  const companyShareWithVat = roundToTwo(companyShare + companyTaxAmount)

  return {
    patient_share: isCash ? 100 : patientSharePercent,
    patientShareAmount: roundToTwo(patientShareAmount),
    patient_share_amount: roundToTwo(patientShareAmount),
    patient_tax_amount: roundToTwo(patientTaxAmount),
    patient_share_with_vat: patientShareWithVat,
    company_share: roundToTwo(companyShare),
    company_tax_amount: roundToTwo(companyTaxAmount),
    company_share_with_vat: companyShareWithVat,
    payer_share: roundToTwo(companyShare),
    net: roundToTwo(netPayableAmount),
    net_payable_amount: roundToTwo(netPayableAmount),
    total_amount: roundToTwo(patientShareWithVat + companyShareWithVat),
    tax_amount: roundToTwo(patientTaxAmount + companyTaxAmount)
  }
}

const EmrOrderItem = ({
  selectedPatientData,
  visitData,
  emrFormData,
  coverageBool,
  design = 'new'
}) => {
  const { t, i18n } = useTranslation()
  const [openAddItemsModal, setOpenItemsModal] = useState()
  const [itemAddedBlink, setItemAddedBlink] = useState(false)
  const { values, setFieldValue } = useFormikContext()
  const patientGender =
    selectedPatientData?.gender ||
    visitData?.patient?.gender ||
    emrFormData?.patient?.gender ||
    ''
  const isPregnant =
    values?.pregnancy !== undefined
      ? values.pregnancy === true
      : emrFormData?.medical_case_attribute?.pregnancy === true
  const isCashPatient =
    visitData?.visit_payment_type == 'cash' ||
    emrFormData?.visit?.visit_payment_type == 'cash'
  const { cashPayers } = useSelector(state => state?.visits)
  const cashPayerId = cashPayers?.[0]?.payer_id
  const insurancePatientId =
    selectedPatientData?.selected_plan?.his_payer_id ||
    selectedPatientData?.selected_plan?.payer_id
  const showSessionPrice = values?.items?.some(
    item => Number(item?.number_of_sessions) > 1
  )
  const { data, loading, executeFetch } = useFetchData()
  const isPractitioner = useSelector(
    state => state.auth.user?.role?.name_en == 'Practitioner'
  )
  const isRcmAssistant = useSelector(
    state => state.auth.user?.role?.name_en == 'Rcm Assistant'
  )
  const businessInfo = useSelector(state => state.auth?.buisnessInfo)
  const currentUser = useSelector(state => state.auth.user)
  const hideEmrDiscount = isHideEmrDiscount(currentUser)
  const disableEmrUnitPrice = isDisableEmrUnitPrice(currentUser)
  const hideUnitPrice = isHideEmrUnitPrice(currentUser)
  const [sideDivHeight, setSideDivHeight] = useState(null)
  const [node, setNode] = useState(null)
  const [main, setMain] = useState(false)

  const [selectedPriceListType, setSelectedPriceListType] = useState('')
  const [selectedData, setSelectedData] = useState(null)
  const [updatedIndex, setUpdatedIndex] = useState(-1)
  const [Favorite, setFavorite] = useState(false)
  const [showDentalModal, setShowDentalModal] = useState(false)
  const [dentalModalItemIndex, setDentalModalItemIndex] = useState(-1)

  const [pharmacyProviders, setPharmacyProviders] = useState([])
  const [defaultPharmacyProvider, setDefaultPharmacyProvider] = useState('')
  const [selectedPharmacyProvider, setSelectedPharmacyProvider] = useState('')

  useEffect(() => {
    const loadPharmacyProviders = async () => {
      try {
        const res = await fetchData('GET', '/v3/pharmacy/providers')
        const providers = res?.data?.providers || res?.providers || []
        const defaultProvider =
          res?.data?.default_provider || res?.default_provider || ''
        setPharmacyProviders(providers)
        setDefaultPharmacyProvider(defaultProvider)
        setSelectedPharmacyProvider(
          defaultProvider || providers?.[0]?.code || providers?.[0]?.name || ''
        )
      } catch (error) {
        console.error('Error loading pharmacy providers:', error)
      }
    }
    loadPharmacyProviders()
  }, [])

  useEffect(() => {
    if (selectedData?.is_favorite) {
      setFavorite(true)
    }
  }, [selectedData])

  useEffect(() => {
    if (!node) return
    const rect = node.getBoundingClientRect()
    setSideDivHeight(rect.height)
  }, [node])

  const fetchTypeData = async () => {
    await executeFetch('POST', '/v3/pricelist_types/get', {})
  }
  useEffect(() => {
    fetchTypeData()
  }, [])

  const ActionTempelate = row => {
    const actualIndex = values?.items?.findIndex(
      it =>
        it.id === row.id ||
        (it.non_standard_code === row.non_standard_code &&
          it.item_category === row.item_category)
    )
    return (
      <div className='flex items-center justify-center gap-2'>
        <EditIcon
          iconSize='20'
          onClick={() => {
            setOpenItemsModal(true)
            setSelectedData(row)
            setUpdatedIndex(actualIndex)
          }}
        />
        <DeleteIcon
          iconSize='20'
          onClick={() => {
            const updatedItems = values?.items?.filter(
              (_, i) => i !== actualIndex
            )
            setFieldValue('items', updatedItems)
          }}
        />
      </div>
    )
  }

  const handleItemCategoryChange = (index, newCategory) => {
    const currentItems = values?.items || []
    const item = currentItems[index]
    if (!item) return
    if (isCashPatient) {
      toast.error(t('Cannot change item category on a cash visit.'))
      return
    }
    const isInsurance = newCategory?.toLowerCase() === 'insurance'
    const isSaudiPatient =
      selectedPatientData?.nationality?.toLowerCase() === 'saudi'
    const planPatientShare =
      selectedPatientData?.selected_plan?.patient_share ??
      selectedPatientData?.insurance_plans?.[0]?.patient_share
    const updatedShares = recalculateItemShares(
      {
        ...item,
        item_category: newCategory,
        payer_id: isInsurance ? insurancePatientId : cashPayerId,
        patient_share: isInsurance
          ? planPatientShare ?? 0
          : 100
      },
      { isSaudiPatient }
    )
    setFieldValue(`items[${index}]`, {
      ...item,
      ...updatedShares,
      payer_id: isInsurance ? insurancePatientId : cashPayerId,
      is_approval: isInsurance,
      approval_status: isInsurance ? 'pending' : 'approved',
      is_approval_sent: false,
      approval_number: '',
      rejection_reason: ''
    })
    toast.success(
      t(
        isInsurance
          ? 'Item category changed to insurance. Approval will be sent on save.'
          : 'Item category changed to cash.'
      )
    )
  }

  const columns = [
    ...itemstableColumns(t, data?.data || [], i18n),
    {
      header: t('Actions'),
      body: ActionTempelate,
      headerCellClass: '!bg-gray-300'
    }
  ]

  const baseCategories = data?.data
    ? data.data.filter(
        type =>
          levenshtein(type?.category?.toLowerCase() || '', 'medication-codes') >
          2
      )
    : []

  const resolvedCategories = [...baseCategories]
  const businessPharmacyLabel = `${
    businessInfo?.business_name ||
    businessInfo?.name_en ||
    businessInfo?.name_ar ||
    'Business'
  } Pharmacy`

  resolvedCategories.push({
    name_en: businessPharmacyLabel,
    name_ar: businessPharmacyLabel,
    id: 'medication-codes',
    category: 'medication-codes',
    providerCode: LOCAL_PHARMACY_PROVIDER_CODE
  })

  if (pharmacyProviders && pharmacyProviders.length > 0) {
    pharmacyProviders.forEach(provider => {
      const isDefault = provider.code?.toLowerCase() === 'default'

      if (isDefault) {
        resolvedCategories.push({
          name_en: t('Medicines (sfda)'),
          name_ar: 'اس اف دي اي',
          id: 'medication-codes',
          category: 'medication-codes',
          providerCode: provider.code
        })
      } else {
        resolvedCategories.push({
          name_en: provider.name || provider.code,
          name_ar: provider.name_ar || provider.name || provider.code,
          id: 'medication-codes',
          category: 'medication-codes',
          providerCode: provider.code
        })
      }
    })
  } else {
    resolvedCategories.push({
      name_en: t('Medicines (sfda)'),
      name_ar: 'اس اف دي اي',
      id: 'medication-codes',
      category: 'medication-codes',
      providerCode: defaultPharmacyProvider || 'default'
    })
  }

  const categoriesToMap = resolvedCategories

  const totalGrossPrice =
    values?.items?.reduce((sum, itm) => {
      if (itm?.status?.toLowerCase() === 'cancelled') return sum
      const uPrice = Number(itm?.original_price ?? itm?.unit_price ?? 0)
      const qty = Number(itm?.quantity) || 0
      return sum + uPrice * qty
    }, 0) || 0

  const totalNetPrice =
    values?.items?.reduce((sum, itm) => {
      if (itm?.status?.toLowerCase() === 'cancelled') return sum
      const uPrice = Number(itm?.original_price ?? itm?.unit_price ?? 0)
      const qty = Number(itm?.quantity) || 0
      const gross = uPrice * qty
      const disc =
        itm?.discount_type === 'fixed'
          ? Number(itm?.discount_amount) || 0
          : (gross * (Number(itm?.discount_amount) || 0)) / 100
      return sum + Math.max(gross - disc, 0)
    }, 0) || 0

  const totalDiscount = Math.max(totalGrossPrice - totalNetPrice, 0)

  return (
    <div className=' animate-in fade-in duration-300'>
      <div
        className={`${
          design === 'new'
            ? 'bg-gray-50 border border-[#e2e8f0] p-3 rounded-lg '
            : 'mt-4'
        }`}
      >
        <div className='flex flex-col gap-4'>
          <div className='flex  justify-between items-center'>
            {design === 'old' ? (
              <div>
                <CardHeading title={'Order Items'} Icon={FaCartPlus} />
              </div>
            ) : null}
            <div className='flex flex-wrap gap-2 items-center justify-end'>
              <CustomChip
                chipType='primary'
                icon={<MdOutlineAdd />}
                label={t('Add New')}
                onClick={() => {
                  if (!values?.diagnosisArray?.length) {
                    toast.error(
                      t('DiagnosisMissingPleaseAddDiagnosisBeforeAddingItems')
                    )
                    return
                  }
                  setOpenItemsModal(true)
                  setMain(true)
                }}
                labelClassName='!w-[75px]'
                className='h-[30px] min-w-[100px]  px-2 rounded-md cursor-pointer'
              />
              {/* {isPractitioner && <CDSSReport />} */}
            </div>
          </div>
          <div className='flex flex-wrap gap-5'>
            <div className='flex flex-wrap gap-2'>
              {resolvedCategories.map((type, index) => (
                <div
                  key={index}
                  onClick={() => {
                    if (!values?.diagnosisArray?.length) {
                      toast.error(
                        t('DiagnosisMissingPleaseAddDiagnosisBeforeAddingItems')
                      )
                      return
                    }
                    if (
                      type.category === 'medication-codes' &&
                      type.providerCode
                    ) {
                      setSelectedPharmacyProvider(type.providerCode)
                    }
                    setSelectedPriceListType(type)
                    setMain(false)
                    setOpenItemsModal(true)
                  }}
                  className='flex items-center gap-2 py-1 rounded-md px-2 bg-white border border-gray-200 cursor-pointer'
                >
                  <p>{getPriceListIcon(type?.name_en)}</p>
                  <h6 className='text-14-dark !font-normal'>
                    {i18n.language === 'ar' ? type?.name_ar : type?.name_en}
                  </h6>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div class='overflow-auto border border-gray-200 rounded-t mt-2 border-b-0 custom-table'>
          <table class='min-w-[50rem] w-full border-collapse'>
            <thead class='bg-gray-300'>
              <tr>
                {TableHeader.filter(header => {
                  if (header === 'Apv No' && isPractitioner) {
                    return false
                  }
                  if (header === 'U.Price' && hideUnitPrice) {
                    return false
                  }
                  if (header === 'Disc' && hideEmrDiscount) {
                    return false
                  }
                  if (isRcmAssistant) {
                    return ![
                      'Days Supply',
                      'Instructions',
                      'Route',
                      'Frequency',
                      'Dose'
                    ].includes(header)
                  }
                  if (header === 'Instructions') {
                    return false
                  }
                  return true
                })
                  .reduce((acc, header) => {
                    acc.push(header)
                    if (isRcmAssistant && header === 'Apv Req') {
                      acc.push('Approval Status')
                    }
                    if (isRcmAssistant && header === 'Apv No') {
                      acc.push('Rejection Reason', 'Invoice No.')
                    }
                    return acc
                  }, [])
                  .map((header, index) => {
                    const shortTitles = {
                      Actions: 'Actions',
                      'Itm Type': 'Type',
                      'Itm Ctg': 'Ctg',
                      Item: 'Item',

                      'Body Site': 'Body Site',
                      'U.Price': 'U.P',
                      Qty: 'Qty',
                      Disc: 'Disc',
                      'Net Price': 'Net Price',
                      'Days Supply': 'Days Supply',
                      Frequency: 'Freq',
                      'Apv Req': 'Ap.R',
                      'Apv No': 'Approval Number',
                      'Approval Status': 'Approval Status',
                      'Rejection Reason': 'Rejection Reason',
                      'Invoice No.': 'Invoice Number',
                      'Pt.Sh (%)': 'Pt.Sh (%)'
                    }
                    const fullTitles = {
                      Item: 'Item Name',

                      'Body Site': 'Body Site',
                      'U.Price': 'Unit Price',
                      Qty: 'Quantity',
                      Disc: 'Discount',
                      'Net Price': 'Net Price',
                      'Days Supply': 'Days Supply',
                      'Apv Req': 'Approval Required',
                      'Apv No': 'Approval Number',
                      'Itm Type': 'Item Type',
                      'Itm Ctg': 'Item Category',
                      'Approval Status': 'Approval Status',
                      'Rejection Reason': 'Rejection Reason',
                      'Invoice No.': 'Invoice Number',
                      'Pt.Sh (%)': 'Patient Share Percentage'
                    }
                    return (
                      <th
                        key={index}
                        title={t(fullTitles[header] || header)}
                        class='!px-[0.35rem] !py-[0.6rem] text-left text-[14px] font-semibold text-gray-800 whitespace-nowrap'
                      >
                        {t(shortTitles[header] || header)}
                      </th>
                    )
                  })}
              </tr>
            </thead>
            <tbody>
              {values?.items?.length > 0 ? (
                values.items.map((itm, idx) => {
                  const unitPrice = Number(itm?.original_price ?? itm?.unit_price ?? 0)
                  const quantity = Number(itm?.quantity) || 0
                  const grossPrice = unitPrice * quantity
                  const discountVal = Math.max(Number(itm?.discount_amount) || 0, 0)
                  const discountAmt =
                    itm?.discount_type === 'fixed'
                      ? discountVal
                      : (grossPrice * discountVal) / 100
                  const netPrice = Math.max(grossPrice - discountAmt, 0)
                  return (
                  <tr
                    key={idx}
                    className={`hover:bg-gray-100 cursor-pointer ${
                      itm?.status?.toLowerCase() === 'cancelled'
                        ? 'bg-red-100'
                        : itm?.approval_status === 'approved'
                        ? 'bg-green-50'
                        : itm?.approval_status === 'rejected'
                        ? 'bg-red-50'
                        : ''
                    }`}
                  >
                    <td className='!px-[0.35rem] !py-[0.6rem] text-[12px] text-gray-600 border-b border-gray-200 text-center'>
                      <div
                        className={`
                        flex gap-1 h-full
                        ${
                          isRcmAssistant && itm?.item_category === 'cash'
                            ? 'hidden'
                            : ''
                        }
                      `}
                      >
                        {(isRcmAssistant || itm?.status !== 'Paid') &&
                          itm?.status?.toLowerCase() !== 'cancelled' && (
                            <EditIcon
                              iconSize={18}
                              onClick={() => {
                                setOpenItemsModal(true)
                                setSelectedData(itm)
                                setUpdatedIndex(idx)
                              }}
                            />
                          )}

                        {itm?.status !== 'Paid' &&
                          itm?.status?.toLowerCase() !== 'cancelled' && (
                            <FieldArray name='items'>
                              {({ remove }) => (
                                <DeleteIcon
                                  iconSize={18}
                                  onClick={() => remove(idx)}
                                />
                              )}
                            </FieldArray>
                          )}
                      </div>
                    </td>

                    <td className='!px-[0.35rem] !py-[0.6rem] text-[12px] text-gray-600 border-b border-gray-200'>
                      {itm?.selected_category || '-'}
                    </td>

                    <td className='!px-[0.35rem] !py-[0.6rem] text-[12px] text-gray-600 border-b border-gray-200'>
                      {itm?.item_category?.toLowerCase() === 'cash' &&
                      !isCashPatient &&
                      (itm?.is_approval_sent === true ||
                        itm?.is_approval_sent === 'true') ? (
                        <div className='flex flex-col items-start gap-1'>
                          <span className='capitalize'>
                            {itm?.item_category || '-'}
                          </span>
                          <button
                            type='button'
                            onClick={() =>
                              handleItemCategoryChange(idx, 'insurance')
                            }
                            className='flex items-center gap-1 px-2 py-0.5 bg-primary/10 text-primary text-[10px] font-semibold rounded-full hover:bg-primary/20 transition'
                            title={t('Convert to Insurance')}
                          >
                            {t('Convert to Insurance')}
                          </button>
                        </div>
                      ) : (
                        itm?.item_category || '-'
                      )}
                    </td>

                    <td className='!px-[0.35rem] !py-[0.6rem] text-[12px] text-gray-600 border-b border-gray-200'>
                      <div className='text-blue font-medium'>
                        {itm?.non_standard_code || itm?.standard_code || '-'}
                      </div>
                      <div>
                        {i18n.language === 'en'
                          ? itm?.non_standard_description ||
                            itm?.item_name ||
                            itm?.standard_description ||
                            '-'
                          : itm?.non_standard_description_ar ||
                            itm?.item_name ||
                            itm?.standard_description_ar ||
                            '-'}
                      </div>
                    </td>
                    <td className='!px-[0.35rem] !py-[0.6rem] text-[12px] text-gray-600 border-b border-gray-200'>
                      {['oral-health-op', 'dental'].includes(
                        itm?.selected_category
                      ) ? (
                        <div className='flex items-center gap-1'>
                          <FaTooth
                            className='text-primary cursor-pointer hover:scale-110 transition-transform'
                            size={14}
                            onClick={() => {
                              setDentalModalItemIndex(idx)
                              setShowDentalModal(true)
                            }}
                            title={t('Open Dental Chart')}
                          />
                          {itm?.body_site && (
                            <button
                              type='button'
                              onClick={() => {
                                setDentalModalItemIndex(idx)
                                setShowDentalModal(true)
                              }}
                              className='flex items-center gap-1 px-2 py-0.5 bg-primary text-white text-[11px] font-bold rounded-full shadow hover:opacity-80 transition'
                              title={t('View/Change selected tooth')}
                            >
                              <FaTooth size={10} />
                              {itm.body_site}
                            </button>
                          )}
                        </div>
                      ) : (
                        <div className='relative flex items-center gap-1'>
                          <DropdownField
                            disabled={itm?.status?.toLowerCase() == 'cancelled'}
                            name={`items[${idx}].body_site`}
                            placeholder={t('Select body site')}
                            options={body_siteitems}
                          />
                        </div>
                      )}
                    </td>

                    {!hideUnitPrice && (
                    <td className='!px-[0.35rem] !py-[0.6rem] text-[12px] text-gray-600 border-b border-gray-200'>
                      <TextInput
                        readOnly={
                          disableEmrUnitPrice ||
                          itm?.status?.toLowerCase() == 'cancelled' ||
                          itm?.status?.toLowerCase() == 'paid'
                        }
                        value={itm?.original_price}
                        type='number'
                        name={`items[${idx}].original_price`}
                        onChange={e => {
                          const val =
                            e.target.value === '' ? '' : Number(e.target.value)
                          setFieldValue(`items[${idx}].original_price`, val)
                          const sessions = itm?.number_of_sessions || 0
                          const calculatedUnitPrice = (
                            sessions ? val / sessions : val || 0
                          ).toFixed(2)
                          setFieldValue(
                            `items[${idx}].unit_price`,
                            calculatedUnitPrice
                          )
                          if (itm?.is_approval) {
                            setFieldValue(
                              `items[${idx}].approved_amount`,
                              calculatedUnitPrice
                            )
                          }
                        }}
                        placeholder={t('Unit Price')}
                        step='any'
                      />
                    </td>
                    )}
                    <td className='!px-[0.35rem] !py-[0.6rem] text-[12px] text-gray-600 border-b border-gray-200'>
                      <TextInput
                        readOnly={
                          itm?.status?.toLowerCase() == 'cancelled' ||
                          itm?.status?.toLowerCase() == 'paid'
                        }
                        value={itm?.quantity}
                        type='number'
                        name={`items[${idx}].quantity`}
                        placeholder={t('Quantity')}
                        onChange={e => {
                          const val =
                            e.target.value === '' ? '' : Number(e.target.value)
                          if (
                            !itm?.is_nahdi_pharmacy &&
                            isQuantityOverStock(itm, val)
                          ) {
                            showStockLimitToast(toast, itm?.stock)
                            return
                          }
                          setFieldValue(`items[${idx}].quantity`, val)
                          if (itm?.is_approval) {
                            setFieldValue(`items[${idx}].approved_qty`, val)
                          }
                        }}
                      />
                    </td>
                    {!hideEmrDiscount && (
                    <td className='!px-[0.35rem] !py-[0.6rem] text-[12px] text-gray-600 border-b border-gray-200'>
                      <TextInput
                        readOnly={
                          itm?.status?.toLowerCase() == 'cancelled' ||
                          itm?.status?.toLowerCase() == 'paid'
                        }
                        value={itm?.discount_amount}
                        onChange={e => {
                          const val =
                            e.target.value === '' ? '' : Number(e.target.value)
                          setFieldValue(`items[${idx}].discount_amount`, val)
                        }}
                        type='number'
                        name={`items[${idx}].discount_amount`}
                        placeholder={t('Disc')}
                        step='any'
                      />
                    </td>
                    )}
                    <td className='!px-[0.35rem] !py-[0.6rem] text-[12px] text-gray-600 border-b border-gray-200'>
                      <div className='px-2 py-1 bg-gray-100 border border-gray-200 rounded text-center text-gray-800 text-[12px]'>
                        {netPrice.toFixed(2)}
                      </div>
                    </td>
                    {!isRcmAssistant && (
                      <td className='!px-[0.35rem] !py-[0.6rem] text-[12px] text-gray-600 border-b border-gray-200'>
                        {itm?.selected_category === 'medication-codes' ? (
                          <TextInput
                            disabled={itm?.status?.toLowerCase() == 'cancelled'}
                            value={itm?.days_supply}
                            type='number'
                            name={`items[${idx}].days_supply`}
                            onChange={e => {
                              const val = e.target.value.replace(/\D/g, '')
                              setFieldValue(`items[${idx}].days_supply`, val)
                              const requiresApproval =
                                itm?.item_category?.toLowerCase() ===
                                  'insurance' && Number(val) > 30
                              const isCashApprovalFree =
                                isCashPatient ||
                                itm?.item_category?.toLowerCase() === 'cash'
                              const isApprovalRequired = isCashApprovalFree
                                ? false
                                : requiresApproval ||
                                  itm?.is_approval === true
                              setFieldValue(
                                `items[${idx}].is_approval`,
                                isApprovalRequired
                              )
                              setFieldValue(
                                `items[${idx}].approval_status`,
                                isApprovalRequired ? 'pending' : 'approved'
                              )
                              if (requiresApproval) {
                                setFieldValue(
                                  `items[${idx}].approved_qty`,
                                  itm?.quantity
                                )
                              }
                            }}
                            placeholder={t('Days Supply')}
                            step='any'
                          />
                        ) : (
                          '---'
                        )}
                      </td>
                    )}
                    {!isRcmAssistant &&
                      (itm?.selected_category === 'medication-codes' ? (
                        <>
                          <td className='!px-[0.35rem] !py-[0.6rem] text-[12px] text-gray-600 border-b border-gray-200'>
                            <DropdownField
                              name={`items[${idx}].route`}
                              options={(routeOptions || []).map(opt => ({
                                ...opt,
                                label:
                                  opt.label.split(' - ')[
                                    i18n.language === 'ar' ? 1 : 0
                                  ]
                              }))}
                              placeholder={t('Route')}
                            />
                          </td>
                          <td className='!px-[0.35rem] !py-[0.6rem] text-[12px] text-gray-600 border-b border-gray-200'>
                            <DropdownField
                              name={`items[${idx}].frequency`}
                              options={(frequencyOptionss || []).map(opt => ({
                                ...opt,
                                label:
                                  opt.label.split(' - ')[
                                    i18n.language === 'ar' ? 1 : 0
                                  ]
                              }))}
                              placeholder={t('Frequency')}
                            />
                          </td>
                          <td className='!px-[0.35rem] !py-[0.6rem] text-[12px] text-gray-600 border-b border-gray-200'>
                            <TextInput
                              value={itm?.dosage || ''}
                              type='text'
                              name={`items[${idx}].dosage`}
                              placeholder={t('Dosage')}
                            />
                          </td>
                        </>
                      ) : (
                        <>
                          <td className='!px-[0.35rem] !py-[0.6rem] text-[12px] text-gray-600 border-b border-gray-200 text-center'>
                            ---
                          </td>
                          <td className='!px-[0.35rem] !py-[0.6rem] text-[12px] text-gray-600 border-b border-gray-200 text-center'>
                            ---
                          </td>
                          <td className='!px-[0.35rem] !py-[0.6rem] text-[12px] text-gray-600 border-b border-gray-200 text-center'>
                            ---
                          </td>
                        </>
                      ))}

                    <td className='!px-[0.35rem] !py-[0.6rem] text-[12px] text-gray-600 border-b border-gray-200 text-center'>
                      <input
                        type='checkbox'
                        checked={itm?.is_approval || false}
                        readOnly
                        className='cursor-pointer accent-primary'
                      />
                    </td>
                    {isRcmAssistant && (
                      <td className='!px-[0.35rem] !py-[0.6rem] text-[12px] text-gray-600 border-b border-gray-200'>
                        <DropdownField
                          disabled={itm?.status?.toLowerCase() == 'cancelled'}
                          name={`items[${idx}].approval_status`}
                          options={approvalStatusOptions(t)}
                          placeholder={t('Approval Status')}
                          onChange={event => {
                            setFieldValue(
                              `items[${idx}].approval_status`,
                              event.value
                            )
                            setFieldValue(
                              `items[${idx}].is_approved_manually`,
                              String(event.value || '').toLowerCase() ===
                                'approved'
                            )
                          }}
                        />
                      </td>
                    )}
                    {!isPractitioner && (
                      <td className='!px-[0.35rem] !py-[0.6rem] text-[12px] text-gray-600 border-b border-gray-200'>
                        {isRcmAssistant ? (
                          <TextInput
                            readOnly={itm?.status?.toLowerCase() == 'cancelled'}
                            value={itm?.approval_number || ''}
                            type='text'
                            name={`items[${idx}].approval_number`}
                            placeholder={t('Approval Number')}
                          />
                        ) : (
                          itm?.approval_number || '-'
                        )}
                      </td>
                    )}
                    {isRcmAssistant && (
                      <>
                        <td className='!px-[0.35rem] !py-[0.6rem] text-[12px] text-gray-600 border-b border-gray-200'>
                          {itm?.approval_status === 'rejected' ? (
                            <TextInput
                              value={itm?.rejection_reason || ''}
                              type='text'
                              name={`items[${idx}].rejection_reason`}
                              placeholder={t('Rejection Reason')}
                            />
                          ) : (
                            '---'
                          )}
                        </td>
                        <td className='!px-[0.35rem] !py-[0.6rem] text-[12px] text-gray-600 border-b border-gray-200'>
                          <TextInput
                            readOnly={itm?.status?.toLowerCase() == 'cancelled'}
                            value={itm?.invoice_no || ''}
                            type='number'
                            name={`items[${idx}].invoice_no`}
                            onChange={e => {
                              const val =
                                e.target.value === ''
                                  ? ''
                                  : Number(e.target.value)
                              setFieldValue(`items[${idx}].invoice_no`, val)
                            }}
                            placeholder={t('Invoice Number')}
                          />
                        </td>
                      </>
                    )}
                  </tr>
                )})
              ) : (
                <tr className='hover:bg-gray-100 cursor-pointer'>
                  <td
                    colSpan={15}
                    className='!px-[0.35rem] !py-[0.6rem] text-center text-[12px] text-gray-600 border-b border-gray-200'
                  >
                    {t('No Items Found')}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {values?.items?.length > 0 ? (
          <div className='flex flex-wrap items-center justify-between gap-4 px-4 py-2 bg-gray-50 border border-gray-200 border-t-0 rounded-b text-sm'>
            <div className='text-gray-600 font-medium'>
              {t('Total Items')}: <span className='text-gray-900 font-bold'>{values.items.filter(it => it?.status?.toLowerCase() !== 'cancelled').length}</span>
            </div>
            <div className='flex items-center gap-6'>
              <div className='text-gray-600 font-medium'>
                {t('Total Price')}: <span className='text-gray-900 font-bold'>{totalGrossPrice.toFixed(2)}</span>
              </div>
              {!hideEmrDiscount && (
                <div className='text-gray-600 font-medium'>
                  {t('Total Discount')}: <span className='text-gray-900 font-bold'>{totalDiscount.toFixed(2)}</span>
                </div>
              )}
              <div className='text-gray-600 font-medium'>
                {t('Total Net Price')}: <span className='text-primary font-bold text-[15px]'>{totalNetPrice.toFixed(2)}</span>
              </div>
            </div>
          </div>
        ) : (
          <div className='border-t border-gray-200' />
        )}
      </div>

      <ReusableModal
        HeaderIcon={FaList}
        className=' w-[90%] h-auto'
        isVisible={openAddItemsModal}
        onClose={() => {
          setOpenItemsModal(false)
          setSelectedPriceListType(null)
          setSelectedData(null)
          setUpdatedIndex(-1)
          setMain(false)
          setFavorite(false)
        }}
        title={
          selectedData
            ? t('UpdateItem')
            : `${t('Add Item')} ( ${values?.items?.length || 0} )`
        }
        headerClassName={
          itemAddedBlink
            ? '!bg-green-400 !text-white [&_h5]:!text-white [&_.icon-bg-container]:!bg-white/20'
            : ''
        }
        {...(!selectedData
          ? { favIcon: <HeartIcon onChange={setFavorite} active={Favorite} /> }
          : {})}
        position='top'
      >
        <AddItemFields
          selectedPatientData={selectedPatientData}
          setFavorite={setFavorite}
          Favorite={Favorite}
          sideDivRef={setNode}
          visitData={visitData}
          emrFormData={emrFormData}
          sideDivHeight={sideDivHeight}
          selectedPriceListType={selectedPriceListType}
          setSelectedPriceListType={setSelectedPriceListType}
          emrFormValues={values}
          selectedData={selectedData}
          setOpenItemsModal={setOpenItemsModal}
          setUpdatedIndex={setUpdatedIndex}
          updatedIndex={updatedIndex}
          setSelectedData={setSelectedData}
          main={main}
          coverageBool={coverageBool}
          pharmacyProviders={pharmacyProviders}
          defaultPharmacyProvider={defaultPharmacyProvider}
          selectedPharmacyProvider={selectedPharmacyProvider}
          setSelectedPharmacyProvider={setSelectedPharmacyProvider}
          businessPharmacyLabel={businessPharmacyLabel}
          onDentalItemAdded={itemIndex => {
            setOpenItemsModal(false)
            setDentalModalItemIndex(itemIndex)
            setShowDentalModal(true)
          }}
          onItemAdded={() => {
            setItemAddedBlink(true)
            setTimeout(() => setItemAddedBlink(false), 1200)
          }}
        />
      </ReusableModal>

      {showDentalModal && dentalModalItemIndex !== -1 && (
        <ReusableModal
          HeaderIcon={FaTooth}
          isVisible={showDentalModal}
          onClose={() => {
            setShowDentalModal(false)
            setDentalModalItemIndex(-1)
          }}
          title={t('Dental Chart - Select Tooth')}
          className='w-[95%] max-w-[500px]'
          position='top'
        >
          <div className='flex flex-col items-center justify-center p-2 bg-white rounded-xl'>
            <div className='w-full overflow-auto flex justify-center'>
              <DentalSelctedTooth
                item={{
                  items: values?.items?.[dentalModalItemIndex]?.body_site
                    ? [
                        {
                          body_site:
                            values.items[dentalModalItemIndex].body_site
                        }
                      ]
                    : []
                }}
                onSelect={tooth => {
                  setFieldValue(
                    `items[${dentalModalItemIndex}].body_site`,
                    tooth
                  )
                  setShowDentalModal(false)
                  setDentalModalItemIndex(-1)
                }}
              />
            </div>
            {values?.items?.[dentalModalItemIndex]?.body_site && (
              <div className='mt-4 flex items-center gap-3'>
                <span className='text-sm font-medium text-gray-500'>
                  {t('Current Selection')}:
                </span>
                <span className='px-4 py-1.5 bg-primary text-white text-sm font-bold rounded-full shadow-md'>
                  {values.items[dentalModalItemIndex].body_site}
                </span>
              </div>
            )}
            <p className='mt-2 text-xs text-gray-500 text-center'>
              {t('Click on a tooth to select or change selection')}
            </p>
          </div>
        </ReusableModal>
      )}
    </div>
  )
}

export const AddItemFields = ({
  setFavorite,
  Favorite,
  sideDivRef,
  sideDivHeight,
  selectedData,
  setOpenItemsModal,
  updatedIndex,
  setUpdatedIndex,
  setSelectedData,
  emrFormValues,
  selectedPriceListType,
  setSelectedPriceListType,
  main = false,
  visitData,
  emrFormData,
  coverageBool,
  onItemAdded,
  pharmacyProviders,
  defaultPharmacyProvider,
  selectedPharmacyProvider,
  setSelectedPharmacyProvider,
  businessPharmacyLabel,
  onDentalItemAdded
}) => {
  const { t, i18n } = useTranslation()
  const isRcmAssistant = useSelector(
    state => state.auth.user?.role?.name_en == 'Rcm Assistant'
  )
  const isPractitioner = useSelector(
    state => state.auth.user?.role?.name_en == 'Practitioner'
  )
  const currentUser = useSelector(state => state.auth.user)
  const disableEmrUnitPrice = isDisableEmrUnitPrice(currentUser)
  const hideUnitPrice = isHideEmrUnitPrice(currentUser)
  const itemsFormRef = useRef('')
  const addedItemsRef = useRef(new Set())
  const isProcessingRef = useRef(false)
  const [priceListTypes, setPriceListTypes] = useState([])
  const [fieldLoading, setFieldLoading] = useState(false)
  const { auth } = useSelector(state => state)
  const [itemLoading, setItemLoading] = useState(false)
  const [unfavoriteLoading, setUnfavoriteLoading] = useState(null)
  const [showUnfavoriteConfirmation, setShowUnfavoriteConfirmation] =
    useState(false)
  const [itemToUnfavorite, setItemToUnfavorite] = useState(null)
  const [medicationFieldsLoading, setMedicationsFieldsLoading] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState(
    selectedPriceListType?.category || selectedData?.selected_category || null
  )
  const [selectedPriceListTypeData, setSelectedPriceListTypeData] = useState(
    selectedPriceListType?.id || selectedData?.item_type || null
  )
  const isDentalItemCategory = ['oral-health-op', 'dental'].includes(
    selectedCategory
  )
  const [routesOptions, setRoutesOptions] = useState([])
  const roleData = useSelector(state => state.auth.roleData)
  const [frequencyOptions, setFrequencyOptions] = useState([])
  const [searchedPriceItem, setSearchedPriceItem] = useState('')
  const [itemsSuggestions, setItemsSuggestions] = useState([])
  const [Session, setSession] = useState('false')
  const [attachment, setAttachment] = useState('false')
  const { data: FavoriteItems, loading, executeFetch } = useFetchData()
  const [itemToStore, setItemToStore] = useState(null)
  const [showDentalModal, setShowDentalModal] = useState(false)
  const [favTab, setFavTab] = useState('cash')
  const [favSearch, setFavSearch] = useState('')
  const [priceListTypesForOrderItems, setPriceListTypesForOrderItems] =
    useState('')
  const isNahdiPharmacySelected =
    selectedCategory === 'medication-codes' &&
    String(selectedPharmacyProvider || '')
      .toLowerCase()
      .includes('nahdi')

  const { hasPermission } = CheckPermission()
  const isHavePriceListTypePermission = hasPermission('pricelist_types', 'get')
  const isHaveRoutesPermission = hasPermission('route', 'get')
  const isHaveFrequencyPermission = hasPermission('frequency', 'get')
  const { values, setFieldValue } = useFormikContext()
  const parentValues = values
  const selectedPatientData = useSelector(
    state => state?.beneficiary?.seletedPatientData
  )
  const patientGender =
    selectedPatientData?.gender ||
    visitData?.patient?.gender ||
    emrFormData?.patient?.gender ||
    ''
  const isPregnant =
    parentValues?.pregnancy !== undefined
      ? parentValues.pregnancy === true
      : emrFormData?.medical_case_attribute?.pregnancy === true
  const insurancePatientId =
    selectedPatientData?.selected_plan?.his_payer_id ||
    selectedPatientData?.selected_plan?.payer_id
  const { cashPayers } = useSelector(state => state?.visits)
  const cashPayerId = cashPayers?.[0]?.payer_id
  const isCashPatient =
    selectedPatientData?.beneficiary_type == 'cash' ||
    visitData?.visit_payment_type == 'cash' ||
    emrFormData?.visit_payment_type == 'cash'
      ? true
      : false
  const isInsurancePatient = emrFormData?.visit_payment_type?.toLowerCase() != 'cash'
  const [selectedPatientId, setSelectedPatientId] = useState(
    isCashPatient ? cashPayerId : insurancePatientId || null
  )

console.log(isInsurancePatient,selectedPatientId, cashPayerId, insurancePatientId);


  useEffect(() => {
    const fetchFavData = async () => {
      await executeFetch('POST', '/v3/favoriteItem/list', {
        practitioner_id: roleData?.practitioner_id,
        selected_category: selectedCategory ? selectedCategory : '',
        payer_id: selectedPatientId
      })
    }

    fetchFavData()
  }, [])

  const handleUnfavorite = async (favoriteItemId, e) => {
    if (!roleData?.practitioner_id) return
    e.stopPropagation()
    setItemToUnfavorite(favoriteItemId)
    setShowUnfavoriteConfirmation(true)
  }

  const confirmUnfavorite = async () => {
    if (!itemToUnfavorite) return
    setUnfavoriteLoading(itemToUnfavorite)
    try {
      const response = await fetchData(
        'POST',
        `/v3/favoriteItem/delete/${itemToUnfavorite}`,
        {}
      )
      if (response) {
        await executeFetch('POST', '/v3/favoriteItem/list', {
          practitioner_id: roleData?.practitioner_id,
          selected_category: '',
          payer_id: selectedPatientId
        })
      }
    } catch (error) {
      console.error('Error unfavoriting item:', error)
      toast.error(t('Failed to remove item from favorites'))
    } finally {
      setUnfavoriteLoading(null)
      setItemToUnfavorite(null)
      setShowUnfavoriteConfirmation(false)
    }
  }

  const handleSearchItems = async event => {
    const query = event?.query?.trim()
    setItemLoading(true)
    try {
      if (!query || query.length < 2) return setItemsSuggestions([])

      const payerId = selectedPatientId
      const insurancePatient = emrFormData?.visit_payment_type?.toLowerCase() != 'cash'
      const isInsurance = insurancePatient && payerId !== cashPayerId

      const basePayload = {
        search: query,
        price_list_type_id: selectedPriceListTypeData,
        department_id: roleData?.department?.id,
        age: CalculateAgeInYears(selectedPatientData?.dob),
        gender: selectedPatientData?.gender || 'other',
        is_check_master_price: true
      }

      const requestData = async (targetPayerId, type = 'insurance') => {
        try {
          const response = await fetchData(
            'POST',
            '/v3/pricelists/search',
            main
              ? {
                  ...basePayload,
                  payer_id: targetPayerId,
                  item_type: type,
                  price_list_type_id: undefined
                }
              : { ...basePayload, payer_id: targetPayerId, item_type: type }
          )

          const formatedData = response?.data
            ? response.data.map(data => ({
                ...data,
                is_master_price: response?.is_master_price,
                is_vat_applicateable: response?.is_vat_applicateable === true
              }))
            : []
          return { success: true, data: formatedData }
        } catch (error) {
          console.error(
            `Error fetching data for payer ${targetPayerId}:`,
            error
          )
          return { success: false, data: [] }
        }
      }

      try {
        let primaryRes, secondaryRes

        if (isInsurance) {
          primaryRes = await requestData(payerId, 'insurance')
          secondaryRes = await requestData(cashPayerId || payerId, 'cash')
        } else {
          primaryRes = await requestData(payerId, 'cash')
          secondaryRes = null
        }

        const primaryOptions = primaryRes?.success
          ? searchedPriceItemsOptionsFormat(primaryRes.data)
          : []

        const secondaryOptions = secondaryRes?.success
          ? searchedPriceItemsOptionsFormat(secondaryRes.data)
          : []

        if (isInsurance) {
          const combinedData = [
            {
              label: t('Insurance'),
              options: primaryOptions?.map(pr => {
                return {
                  ...pr,
                  fromInsurance: true
                }
              })
            },
            {
              label: t('Cash'),
              options: secondaryOptions
            }
          ].filter(group => group.options && group.options.length > 0)

          setItemsSuggestions(combinedData)
        } else {
          setItemsSuggestions(primaryOptions)
        }
      } catch (error) {
        console.error('Error processing items:', error)
        setItemsSuggestions([])
      }
    } catch (e) {
      console.log('Unexpected error:', e)
      setItemsSuggestions([])
    } finally {
      setItemLoading(false)
    }
  }

  const handleSearchSfdaItems = async event => {
    if (event.query.length < 2) {
      setItemsSuggestions([])
      return false
    }
    setItemLoading(true)
    try {
      const providerCode = String(selectedPharmacyProvider || '').toLowerCase()
      if (selectedPharmacyProvider === LOCAL_PHARMACY_PROVIDER_CODE) {
        const stockRes = await fetchData(
          'GET',
          `/v3/pharmacy/stock?search=${encodeURIComponent(event?.query)}`
        )

        const mappedItems = (stockRes?.data || []).map(it => ({
          ...it,
          register_number:
            it?.register_number ||
            it?.description_code ||
            it?.product_master_code ||
            it?.name ||
            '',
          trade_name: it?.trade_name || it?.name || '',
          trade_name_ar: it?.trade_name || it?.name || '',
          gtin:
            it?.gtn_code ||
            it?.product_master_code ||
            it?.description_code ||
            '',
          public_price: Number(
            it?.public_price ?? it?.purchase_price ?? it?.unit_purchase ?? 0
          ),
          drug_type: String(it?.drug_type || '').toLowerCase(),
          item_code:
            it?.product_master_code || it?.description_code || it?.name || '',
          barcode: it?.gtn_code || it?.product_master_code || '',
          generic_name: it?.scientific_name || it?.name || '',
          generic_strength:
            it?.strength && it?.strength_unit
              ? `${it.strength} ${it.strength_unit}`
              : it?.strength || it?.scientific_name || '',
          second_description:
            it?.pharmaceutical_form ||
            it?.administration_route ||
            it?.scientific_name ||
            it?.name ||
            '',
          item_generic_name: it?.scientific_name || it?.name || ''
        }))

        setItemsSuggestions(
          searchedPriceItemsOptionsFormatSFDA({ data: mappedItems })
        )
      } else if (providerCode.includes('nahdi')) {
        const stockRes = await fetchData(
          'POST',
          `/v3/pharmacy/nahdi/items/search`,
          { search: event?.query }
        )

        const mappedItems = stockRes?.data?.map(it => ({
          ...it,
          register_number:
            it?.item_sfda ||
            it?.item ||
            it?.SFDA_Reg_Code ||
            it?.Item_Code ||
            '',
          trade_name:
            it?.generic_names_strength ||
            it?.item_generic_name ||
            it?.second_description ||
            it?.English_Desc ||
            '',
          trade_name_ar:
            it?.item_desc ||
            it?.generic_names_strength ||
            it?.item_generic_name ||
            it?.second_description ||
            it?.Arabic_Desc ||
            it?.English_Desc ||
            '',
          gtin: it?.gtin || it?.GTIN || it?.nphies_code || '',
          public_price: Number(it?.s_price ?? it?.Price ?? 0),
          drug_type: (
            it?.registration_type ||
            it?.SFDA_Reg_Type ||
            ''
          ).toLowerCase(),
          item_code: it?.item || it?.Item_Code || '',
          barcode: it?.ibc || it?.BarCode || '',
          generic_name:
            it?.generic_names_strength ||
            it?.item_generic_name ||
            it?.GenericName ||
            '',
          generic_strength:
            it?.generic_names_strength || it?.Generic_strength || '',
          stock_quantity: null
        }))

        setItemsSuggestions(
          searchedPriceItemsOptionsFormatSFDA({ data: mappedItems })
        )
      } else {
        const params = new URLSearchParams({
          search: event?.query || '',
          page: '1',
          per_page: '20',
          patient_type: isInsurancePatient ? 'insurance' : ''
        })
        const response = await fetchData('GET', `/v3/sfda/search?${params.toString()}`)
        const mappedItems = (response?.data || []).map(item => ({
          ...item,
          source: 'sfda',
          sfda: item,
          register_number: item?.register_number || '',
          trade_name: item?.trade_name || '',
          trade_name_ar: item?.trade_name || '',
          gtin: item?.gtin || '',
          public_price: Number(item?.public_price ?? 0),
          item_code: item?.supergit_master_code || item?.gtin || item?.register_number || '',
          barcode: item?.gtin || '',
          generic_name: item?.scientific_name || '',
          generic_strength: item?.strength && item?.strength_unit
            ? `${item.strength} ${item.strength_unit}`
            : item?.strength || '',
          second_description: item?.pharmaceutical_form || item?.administration_route || item?.scientific_name || '',
          item_generic_name: item?.scientific_name || ''
        }))
        setItemsSuggestions(
          searchedPriceItemsOptionsFormatSFDA({ data: mappedItems })
        )
      }
    } catch (error) {
      console.error('Failed to fetch SFDA items:', error)
      setItemsSuggestions([])
    } finally {
      setItemLoading(false)
    }
  }

  const handleSelectSearchedItem = async event => {
    if (!event?.value?.value) return

    if (isProcessingRef.current) {
      return
    }

    const itemId = event?.value?.value
    if (addedItemsRef.current.has(itemId)) {
      return
    }

    isProcessingRef.current = true
    addedItemsRef.current.add(itemId)

    try {
      const itemData = event?.value?.item
      const selectedItemPayer = itemData?.payer_details?.[0]
      //const  selectedItemPayer = itemData?.payer_details?.find((data)=>(data?.payer_id==selectedPatientData?.selected_plan?.his_payer_id));
      const patientPayerId = isCashPatient ? cashPayerId : insurancePatientId
      const department =
        auth.roleData?.department?.name_en?.toLowerCase() ||
        visitData?.department?.name_en?.toLowerCase() ||
        visitData?.practitioner?.department?.name_en?.toLowerCase()
      const isInsurance =
        selectedItemPayer?.payer?.category === 'insurance' ||
        event?.value?.fromInsurance
      const isMasterPrice =
        itemData?.is_master_price || selectedItemPayer?.payer?.is_master_price
      const payerVat = isMasterPrice
        ? itemData?.is_vat_applicateable === true
        : selectedItemPayer?.payer?.is_vat_applicable === true

      const selectedServiceDiscount =
        selectedItemPayer?.payer?.service_discount?.find(
          item => item?.service_id === itemData?.price_list_type?.id
        )

      const is_approval = (() => {
        const isDental = department?.includes('dent')

        if (coverageBool === false) {
          return true
        }
        if (coverageBool === true && values?.work_related === true) {
          return false
        }
        if (coverageBool === true && values?.work_related === false) {
          if (isDental || department === 'physiotherapy') {
            return true
          }
          return selectedItemPayer?.is_approval ?? false
        }
        if (values?.work_related && isInsurance) {
          return true
        }
        if (isDental || department === 'physiotherapy') {
          return true
        }
        return selectedItemPayer?.is_approval ?? false
      })()

      const taxCheck =
        itemData?.apply_vat === false ||
        selectedPatientData?.nationality?.toLowerCase() === 'saudi'
          ? false
          : true

      const number_of_sessions = itemData?.session
        ? itemData?.number_of_sessions
        : 0
      const basePrice = isMasterPrice
        ? itemData?.master_price
        : selectedItemPayer?.payer_price ?? 0
      const itemCode = getItemStockCode(itemData, selectedItemPayer)

      if (!isNahdiPharmacySelected && isOutOfStockItem(itemData)) {
        toast.error(getOutOfStockMessage(itemData, selectedItemPayer))
        setSearchedPriceItem('')
        return
      }

      const itemPriceListCategory = itemData?.price_list_type?.category
      setSelectedCategory(itemPriceListCategory)
      setItemToStore(itemData)
      setAttachment(itemData?.attachment === true ? 'true' : 'false')
      setSession(itemData?.session === true ? 'true' : 'false')
      setSelectedPriceListTypeData(itemData?.price_list_type?.id)
      setSearchedPriceItem('')

      const form = itemsFormRef?.current

      if (!form) return
      const itemCategory = selectedItemPayer?.payer?.category
        ? selectedItemPayer.payer.category
        : itemData?.item_type === 'insurance' ||
          itemData?.category === 'insurance' ||
          event?.value?.fromInsurance
        ? 'insurance'
        : 'cash'
      if (
        itemCategory == 'insurance' &&
        visitData?.visit_payment_type?.toLowerCase() == 'cash'
      ) {
        return toast.error(
          'This visit is marked as cash, so insurance items cannot be added.'
        )
      }
      const isCashApprovalFree =
        isCashPatient || itemCategory?.toLowerCase() === 'cash'
      const effectiveIsApproval = !isCashApprovalFree && (isReferralOut(itemData) || is_approval)
      const effectiveApprovalStatus = effectiveIsApproval
        ? 'pending'
        : 'approved'
      await Promise.all([
        form.setFieldValue('item_type', itemData?.price_list_type?.id),
        form.setFieldValue(
          'item_id',
          `${itemData?.id}-${values?.items?.length + 1}`
        ),
        form.setFieldValue('is_stock', itemData?.is_stock),
        form.setFieldValue('stock', itemData?.stock),
        form.setFieldValue(
          'internal_pharmacy',
          itemData?.internal_pharmacy || false
        ),
        form.setFieldValue('is_consumable', itemData?.is_consumable || false),
        form.setFieldValue('tax_check', taxCheck),
        form.setFieldValue('payer_vat', payerVat),
        form.setFieldValue('master_code', itemData?.non_standard_code),
        form.setFieldValue(
          'supergit_master_code',
          itemData?.supergit_master_code || itemData?.non_standard_code || ''
        ),
        form.setFieldValue('status', 'UnPaid'),
        form.setFieldValue('session', itemData?.session),
        form.setFieldValue('attachment', itemData?.attachment),
        form.setFieldValue('standard_code', itemData?.standard_code),
        form.setFieldValue('non_standard_code', itemCode || ''),
        form.setFieldValue('agreed_code', selectedItemPayer?.agreed_code),
        form.setFieldValue(
          'agreed_description',
          selectedItemPayer?.agreed_description ||
            selectedItemPayer?.agreed_description_en ||
            selectedItemPayer?.agreed_description_ar
        ),
        form.setFieldValue(
          'agreed_desc',
          selectedItemPayer?.agreed_description ||
            selectedItemPayer?.agreed_description_en ||
            selectedItemPayer?.agreed_description_ar
        ),
        form.setFieldValue(
          'standard_description',
          itemData?.standard_description
        ),
        form.setFieldValue(
          'non_standard_description',
          itemData?.non_standard_description ||
            selectedItemPayer?.agreed_description ||
            selectedItemPayer?.non_standard_description ||
            ''
        ),
        form.setFieldValue(
          'non_standard_description_ar',
          itemData?.non_standard_description_ar ||
            selectedItemPayer?.agreed_description_ar ||
            selectedItemPayer?.non_standard_description_ar ||
            ''
        ),
        form.setFieldValue('number_of_sessions', number_of_sessions),
        form.setFieldValue(
          'original_price',
          Number((basePrice || 0).toFixed(2))
        ),
        form.setFieldValue(
          'unit_price',
          Number(
            (number_of_sessions
              ? basePrice / number_of_sessions
              : basePrice || 0
            ).toFixed(2)
          )
        ),
        form.setFieldValue(
          'approved_amount',
          Number(
            (number_of_sessions
              ? basePrice / number_of_sessions
              : basePrice || 0
            ).toFixed(2)
          )
        ),
        form.setFieldValue('is_new', true),
        form.setFieldValue('is_sfda', false),
        form.setFieldValue('is_nahdi_pharmacy', false),
        form.setFieldValue(
          'source',
          Object.prototype.hasOwnProperty.call(
            event?.value?.other || {},
            'source'
          )
            ? event?.value?.other?.source || ''
            : ITEM_SOURCE_PRICELIST
        ),
        form.setFieldValue('drug_type', ''),
        form.setFieldValue(
          'approval_status',
          effectiveApprovalStatus
        ),
        form.setFieldValue(
          'discount_amount',
          selectedServiceDiscount?.patient_discount ||
            selectedItemPayer?.payer?.generals?.discount ||
            selectedItemPayer?.discount_percentage ||
            selectedItemPayer?.discount_amount ||
            itemData?.discount_percentage ||
            0
        ),
        form.setFieldValue('is_referral_out', isReferralOut(itemData)),
        form.setFieldValue('is_approval', effectiveIsApproval),
        form.setFieldValue('item_category', itemCategory),
        form.setFieldValue('rejection_reason', ''),
        form.setFieldValue('approval_number', ''),
        form.setFieldValue(
          'payer_id',
          selectedItemPayer?.payer?.his_payer_id ||
            selectedItemPayer?.payer?.payer_id
        ),
        form.setFieldValue(
          'patient_share',
          itemCategory?.toLowerCase() == 'cash'
            ? 100
            : selectedServiceDiscount?.patient_share ||
                (selectedPatientData?.selected_plan?.patient_share ??
                  values?.patient_share ??
                  0)
        ),
        form.setFieldValue('manage_costs', itemData?.manage_costs || [])
      ])

      if (itemData?.price_list_type?.category === 'medication-codes') {
        await Promise.all([
          form.setFieldValue(
            'prescribed_medication',
            itemData?.standard_description
          ),
          form.setFieldValue(
            'prescribed_medication_code',
            itemData?.standard_code
          )
        ])

        if (event?.value?.other) {
          const other = event?.value?.other
          await Promise.all([
            form.setFieldValue('days_supply', other?.days_supply),
            form.setFieldValue('route', other?.route),
            form.setFieldValue('dosage', other?.dosage),
            form.setFieldValue('instructions', other?.instructions),
            form.setFieldValue('frequency', other?.frequency)
          ])
        }
      }
      await form.submitForm()
    } catch (error) {
      console.error(error)
    } finally {
      addedItemsRef.current.delete(itemId)
      isProcessingRef.current = false
    }
  }

  const handleSelectSfdaItem = async event => {
    let itemData = event?.value?.item
    if (itemData?.item || itemData?.Item_Code) {
      itemData = {
        ...itemData,
        register_number:
          itemData.item_sfda ||
          itemData.item ||
          itemData.SFDA_Reg_Code ||
          itemData.Item_Code,
        gtin: itemData.gtin || itemData.nphies_code || itemData.GTIN,
        trade_name:
          itemData?.generic_names_strength ||
          itemData?.item_generic_name ||
          itemData.second_description ||
          itemData.English_Desc,
        trade_name_ar:
          itemData.item_desc ||
          itemData?.generic_names_strength ||
          itemData?.item_generic_name ||
          itemData.second_description ||
          itemData.Arabic_Desc,
        public_price: parseFloat(itemData.s_price ?? itemData.Price) || 0,
        drug_type: (
          itemData.registration_type ||
          itemData.SFDA_Reg_Type ||
          ''
        ).toLowerCase()
      }
    }

    const itemId =
      event?.value?.value || itemData?.register_number || itemData?.gtin

    if (!itemId) return

    if (isProcessingRef.current) {
      return
    }

    if (addedItemsRef.current.has(itemId)) {
      return
    }

    isProcessingRef.current = true
    addedItemsRef.current.add(itemId)

    try {
      const department =
        auth.roleData?.department?.name_en?.toLowerCase() ||
        visitData?.department?.name_en?.toLowerCase() ||
        visitData?.practitioner?.department?.name_en?.toLowerCase()
      const visitPaymentType =
        visitData?.visit_payment_type?.toLowerCase() ||
        emrFormData?.visit_payment_type?.toLowerCase()
      // const isInsurance = itemData?.drug_type && visitPaymentType === "insurance";
      const isInsurance = visitPaymentType === 'insurance'
      const isWorkRelated = values?.work_related === true

      const drugType = itemData?.drug_type?.toLowerCase()

      //     const is_approval = (() => {
      //       if (coverageBool === false) {
      //         return true;
      //       }
      //       if (coverageBool === true && isWorkRelated) {
      //         return false;
      //       }
      //       if (coverageBool === true && !isWorkRelated) {
      //         if ((!itemData?.drug_type && isInsurance) || ["dental", "physiotherapy"].includes(department)) {
      //           return true;
      //         }
      //         return itemData?.is_approval ?? false;
      //       }
      //       // if (isWorkRelated || (!itemData?.drug_type && isInsurance) || ["dental", "physiotherapy"].includes(department)) {
      //       if (isWorkRelated && isInsurance) {
      //         return true;
      //       }
      //       if ((!itemData?.drug_type && isInsurance) || ["dental", "physiotherapy"].includes(department)) {
      //         return true;
      //       }
      //       return itemData?.is_approval ?? false;
      //     })();
      //  const category = itemData?.drug_type && isInsurance ? "insurance" : "cash";
      //     const approvalStatus =
      //       itemData?.drug_type && isInsurance ? "pending" : "approved";

      const is_approval = (() => {
        const isDental = department?.includes('dent')

        if (drugType) {
          if (
            drugType === 'generic' ||
            drugType === 'brand replacable' ||
            drugType === 'nce'
          ) {
            return isDental
          }
          if (
            ['biological', 'medical device', 'radiopharmaceutical'].includes(
              drugType
            )
          ) {
            return true
          }
          if (drugType === 'milk') return false
        }

        if (coverageBool === false) return true
        if (coverageBool === true && isWorkRelated) return false

        if (isDental || department === 'physiotherapy') return true
        if (!itemData?.drug_type) return false

        return itemData?.is_approval ?? false
      })()

      const taxCheck =
        itemData?.apply_vat === false ||
        selectedPatientData?.nationality?.toLowerCase() === 'saudi'
          ? false
          : true

      setSelectedCategory('medication-codes')
      setItemToStore(itemData)
      setAttachment(itemData?.attachment === true ? 'true' : 'false')
      setSession(itemData?.session === true ? 'true' : 'false')
      setSelectedPriceListTypeData('medication-codes')
      setSearchedPriceItem('')

      const form = itemsFormRef?.current

      if (!form) return

      const category =
        drugType === 'milk'
          ? 'cash'
          : itemData?.drug_type && isInsurance
          ? 'insurance'
          : 'cash'
      const isCashApprovalFree =
        isCashPatient || category?.toLowerCase() === 'cash'
      const effectiveIsApproval = !isCashApprovalFree && (isReferralOut(itemData) || is_approval)
      const approvalStatus = effectiveIsApproval ? 'pending' : 'approved'
      const isNahdi = String(selectedPharmacyProvider || '')
        .toLowerCase()
        .includes('nahdi')
      const isProviderPharmacy =
        isNahdi || selectedPharmacyProvider === LOCAL_PHARMACY_PROVIDER_CODE
      const selectedSource = Object.prototype.hasOwnProperty.call(
        event?.value?.other || {},
        'source'
      )
        ? event?.value?.other?.source || ''
        : isProviderPharmacy
        ? ITEM_SOURCE_PROVIDER_PHARMACY
        : ITEM_SOURCE_SFDA
      const selectedMasterCode =
        event?.value?.other?.supergit_master_code ||
        event?.value?.other?.master_code ||
        itemData?.supergit_master_code ||
        itemData?.product_master_code ||
        itemData?.register_number ||
        ''

      await Promise.all([
        form.setFieldValue('item_type', 'medication-codes'),
        form.setFieldValue(
          'item_id',
          `${itemData?.register_number}-${values?.items?.length + 1}`
        ),
        form.setFieldValue('is_stock', false),
        form.setFieldValue('stock', null),
        form.setFieldValue('internal_pharmacy', false),
        form.setFieldValue(
          'pharmacy_provider_code',
          isNahdi ? 'nahdi' : 'default'
        ),
        form.setFieldValue('tax_check', taxCheck),
        form.setFieldValue(
          'master_code',
          event?.value?.other?.master_code || selectedMasterCode
        ),
        form.setFieldValue('supergit_master_code', selectedMasterCode),
        form.setFieldValue('status', 'UnPaid'),
        form.setFieldValue('session', itemData?.session || false),
        form.setFieldValue(
          'number_of_sessions',
          itemData?.number_of_sessions || 0
        ),
        form.setFieldValue('attachment', itemData?.attachment || false),
        form.setFieldValue('standard_code', itemData?.gtin),
        form.setFieldValue('non_standard_code', itemData?.register_number),
        form.setFieldValue('is_referral_out', isReferralOut(itemData)),
        form.setFieldValue('is_approval', effectiveIsApproval),
        form.setFieldValue('non_standard_description', itemData?.trade_name),
        form.setFieldValue(
          'non_standard_description_ar',
          itemData?.trade_name_ar || itemData?.trade_name
        ),
        form.setFieldValue('is_sfda', !isNahdi),
        form.setFieldValue('is_nahdi_pharmacy', isNahdi),
        form.setFieldValue('source', selectedSource),
        form.setFieldValue('drug_type', itemData?.drug_type),
        form.setFieldValue('standard_description', itemData?.trade_name),
        form.setFieldValue('is_new', true),
        form.setFieldValue('item_category', category),
        form.setFieldValue('original_price', itemData?.public_price || 0),
        form.setFieldValue('unit_price', itemData?.public_price || 0),
        form.setFieldValue('approved_amount', itemData?.public_price || 0),
        form.setFieldValue('approval_status', approvalStatus),
        form.setFieldValue('discount_amount', itemData?.discount_amount || 0),
        form.setFieldValue('rejection_reason', ''),
        form.setFieldValue('approval_number', ''),
        form.setFieldValue('payer_id', selectedPatientId)
      ])

      if (form.values?.item_type === 'medication-codes' || event?.value?.sfda) {
        await Promise.all([
          form.setFieldValue('prescribed_medication', itemData?.trade_name),
          form.setFieldValue(
            'prescribed_medication_code',
            itemData?.register_number
          )
        ])

        if (event?.value?.other) {
          const other = event?.value?.other
          await Promise.all([
            form.setFieldValue('days_supply', other?.days_supply),
            form.setFieldValue('route', other?.route),
            form.setFieldValue('dosage', other?.dosage),
            form.setFieldValue('instructions', other?.instructions),
            form.setFieldValue('frequency', other?.frequency)
          ])
        }
      }

      await form.submitForm()
    } catch (error) {
      console.error(error)
    } finally {
      addedItemsRef.current.delete(itemId)
      isProcessingRef.current = false
    }
  }

  // const handleSelectSfdaItem = async (event) => {
  //   if (!event?.value?.value) return;

  //   const itemData = event?.value?.item;
  //   const department = auth.roleData?.department?.name_en?.toLowerCase();
  //   const visitPaymentType =
  //     visitData?.visit_payment_type?.toLowerCase() ||
  //     emrFormData?.visit_payment_type?.toLowerCase();

  //   const isInsurance = visitPaymentType === "insurance";
  //   const isWorkRelated = values?.work_related === true;

  //   const is_approval =
  //     isWorkRelated ||
  //     (itemData?.drug_type && isInsurance) ||
  //     ["dental", "physiotherapy"].includes(department)
  //       ? true
  //       : itemData?.is_approval ?? false;

  //   const taxCheck =
  //     itemData?.apply_vat === false ||
  //     selectedPatientData?.document_id?.startsWith("1")
  //       ? false
  //       : true;

  //   setSelectedCategory("medication-codes");
  //   setItemToStore(itemData);
  //   setSearchedPriceItem("");

  //   const form = itemsFormRef?.current;

  //   if (!form) return;

  //   const category = itemData?.drug_type && isInsurance ? "insurance" : "cash";
  //   const approvalStatus =
  //     itemData?.drug_type && isInsurance ? "pending" : "approved";

  //   await Promise.all([
  //     form.setFieldValue(
  //       "item_id",
  //       `${itemData?.register_number}-${values?.items?.length + 1}`
  //     ),
  //     form.setFieldValue(
  //       "internal_pharmacy",
  //       itemData?.internal_pharmacy || false
  //     ),
  //     form.setFieldValue("tax_check", taxCheck),
  //     form.setFieldValue("master_code", itemData?.register_number),
  //     form.setFieldValue("status", "UnPaid"),
  //     form.setFieldValue("standard_code", itemData?.gtin),
  //     form.setFieldValue("non_standard_code", itemData?.register_number),
  //     form.setFieldValue("is_approval", is_approval),
  //     form.setFieldValue("non_standard_description", itemData?.trade_name),
  //     form.setFieldValue(
  //       "non_standard_description_ar",
  //       itemData?.trade_name_ar || itemData?.trade_name
  //     ),
  //     form.setFieldValue("is_sfda", true),
  //     form.setFieldValue("standard_description", itemData?.trade_name),
  //     form.setFieldValue("is_new", true),
  //     form.setFieldValue("item_category", category),
  //     form.setFieldValue("unit_price", itemData?.public_price || 0),
  //     form.setFieldValue("approved_amount", itemData?.public_price || 0),
  //     form.setFieldValue("approval_status", approvalStatus),
  //   ]);

  //   if (form.values?.item_type === "medication-codes" || event?.value?.sfda) {
  //     await Promise.all([
  //       form.setFieldValue("prescribed_medication", itemData?.trade_name),
  //       form.setFieldValue(
  //         "prescribed_medication_code",
  //         itemData?.register_number
  //       ),
  //     ]);

  //     if (event?.value?.other) {
  //       const other = event?.value?.other;
  //       await Promise.all([
  //         form.setFieldValue("days_supply", other?.days_supply),
  //         form.setFieldValue("route", other?.route),
  //         form.setFieldValue("dosage", other?.dosage),
  //         form.setFieldValue("instructions", other?.instructions),
  //         form.setFieldValue("frequency", other?.frequency),
  //       ]);
  //     }
  //   }

  //   await form.submitForm();
  // };

  useEffect(() => {
    if (selectedData?.favItem) {
      setItemToStore(selectedData?.favItem)
    }
    setSession(selectedData?.session ? 'true' : 'false')
    setAttachment(selectedData?.attachment ? 'true' : 'false')
  }, [selectedData])

  const initialValues = {
    item_type: selectedData?.item_type || selectedPriceListType?.id || '',
    item_id: selectedData?.item_id || '',
    attachment: selectedData?.attachment || false,
    session: selectedData?.session || false,
    number_of_sessions: selectedData?.number_of_sessions || 0,
    standard_description: selectedData?.standard_description || '',
    standard_code: selectedData?.standard_code || '',
    non_standard_code: selectedData?.non_standard_code || '',
    route: selectedData?.route || '',
    dosage: selectedData?.dosage || '',
    internal_pharmacy: selectedData?.internal_pharmacy || false,
    is_consumable: selectedData?.is_consumable || false,
    master_code: selectedData?.master_code || '',
    supergit_master_code:
      selectedData?.source === 'sfda' ||
      selectedData?.source === 'provider_pharmacy'
        ? selectedData?.supergit_master_code || selectedData?.master_code || ''
        : selectedData?.supergit_master_code || '',
    frequency: selectedData?.frequency || '',
    instructions: selectedData?.instructions || '',
    clinical_notes: selectedData?.clinical_notes || '',
    non_standard_description: selectedData?.non_standard_description || '',
    body_site: selectedData?.body_site || '',
    sub_site: selectedData?.sub_site || '',
    is_referral_out: isReferralOut(selectedData),
    service_start_date: selectedData?.service_start_date
      ? new Date(selectedData.service_start_date)
      : new Date(),
    service_end_date: selectedData?.service_end_date
      ? new Date(selectedData.service_end_date)
      : '',
    supporting_info:
      selectedData?.supporting_info ||
      supportingInfoOptions([
        ...emrFormValues?.supportingInfos,
        emrFormValues?.chiefComplaints
      ])?.map(data => data?.value),
    diagnosis:
      selectedData?.diagnosis ||
      diagnosisOptions(emrFormValues?.diagnosisArray)?.map(data => data?.value),
    care_teams:
      selectedData?.care_teams ||
      careTeamsOptions(emrFormValues?.careTeamsArray)?.map(data => data?.value),
    is_package: selectedData?.is_package || false,
    invoice_no: selectedData?.invoice_no || 0,
    quantity: selectedData?.quantity || 1,
    original_price: selectedData?.original_price || 0,
    approved_amount: selectedData?.approved_amount || 0,
    approved_qty: selectedData?.approved_qty || 1,
    approval_status: selectedData?.approval_status || 'pending',
    approval_reason: selectedData?.approval_reason || '',
    is_approved_manually: selectedData?.is_approved_manually || false,
    unit_price: selectedData?.unit_price || 1,
    discount_amount: selectedData?.discount_amount || 0,
    patient_share:
      selectedData?.patient_share ||
      selectedPatientData?.selected_plan?.patient_share ||
      selectedPatientData?.insurance_plans?.[0]?.patient_share,
    tax_amount: selectedData?.tax_amount || 0,
    tax_check:
      selectedData?.tax_check ||
      selectedPatientData?.nationality?.toLowerCase() === 'saudi'
        ? false
        : true,
    factor: selectedData?.factor || 1,
    net: selectedData?.net || 1,
    patientShareAmount: selectedData?.patientShareAmount || 0,
    payer_share: selectedData?.payer_share || 1,
    source: selectedData?.source || '',
    medication_selection_reason:
      selectedData?.medication_selection_reason || 'Generic',
    prescribed_medication: selectedData?.prescribed_medication || '',
    prescribed_medication_code:
      selectedData?.prescribed_medication_code ||
      selectedData?.prescribed_medication ||
      '',
    days_supply: selectedData?.days_supply || 1,
    is_approval: !isCashPatient && selectedData?.item_category?.toLowerCase() === 'insurance' &&
      (isReferralOut(selectedData) || Boolean(selectedData?.is_approval)),
    is_approval_sent: selectedData?.is_approval_sent || false,
    resend_approval: selectedData?.resend_approval || false,
    item_category: selectedData?.item_category || '',
    rejection_reason: selectedData?.rejection_reason || '',
    approval_number: selectedData?.approval_number || '',
    payer_id: selectedData?.payer_id || selectedPatientId,
    manage_costs: selectedData?.manage_costs || []
  }

  const validationSchema = Yup.object().shape({
    item_type: Yup.string().required(t('Price list type is required')),
    standard_description: Yup.string().required(
      t('Standard description is required')
    ),
    non_standard_code: Yup.string().required(t('Non-StandardCodeisrequired')),
    non_standard_description: Yup.string().required(
      t('Non-StandardDescriptionisrequired')
    ),
    body_site: Yup.string(),
    sub_site: Yup.string(),
    service_start_date: Yup.date().required(t('Start date is required')),
    instructions: Yup.string(),
    diagnosis: Yup.array().min(1, t('At least one diagnosis is required')),
    care_teams: Yup.array().min(1, t('At least one care team is required')),
    is_package: Yup.string(),
    quantity: Yup.number()
      .required(t('Quantity is required'))
      .positive(t('Quantity must be positive')),
    discount_amount: Yup.number().min(
      0,
      t('Discount price cannot be negative')
    ),
    patient_share: Yup.number().min(0, t('Patient share cannot be negative')),
    tax_amount: Yup.number().min(0, t('Tax amount cannot be negative')),
    factor: Yup.number(),
    net: Yup.number().required(t('Net value is required')),
    patientShareAmount: Yup.number().min(
      0,
      t('Patient share amount cannot be negative')
    ),
    payer_share: Yup.number().min(0, t('Payer share cannot be negative')),
    medication_selection_reason: Yup.string(),
    // prescribed_medication:
    //   selectedCategory === "medication-codes"
    //     ? Yup.string().required(t("Prescribed medication is required"))
    //     : Yup.string(),

    prescribed_medication_code: Yup.string(),
    days_supply:
      selectedCategory === 'medication-codes'
        ? Yup.number()
            .typeError(t('Days Supply is required'))
            .required(t('Days Supply is required'))
            .moreThan(0, t('Days Supply must be greater than 0'))
        : Yup.number().nullable(),
    manage_costs: Yup.array().of(Yup.object())
  })

  const getPriceListTypes = async () => {
    setFieldLoading(true)
    const response = await fetchData('POST', '/v3/pricelist_types/get', {})
    let formatedData = response?.data
      ? priceListTypesOptionsFormatForOrderItems(response?.data)
      : []
    setPriceListTypes(formatedData)
    setFieldLoading(false)
  }

  useEffect(() => {
    if (isHavePriceListTypePermission) {
      getPriceListTypes()
    }
  }, [isHavePriceListTypePermission])

  useEffect(() => {
    if (selectedCategory === 'medication-codes') {
      getRouteAndFrequencyData(
        setMedicationsFieldsLoading,
        setFrequencyOptions,
        setRoutesOptions,
        isHaveFrequencyPermission,
        isHaveRoutesPermission
      )
    }
  }, [priceListTypesForOrderItems])

  useEffect(() => {
    if (selectedPriceListType) {
      itemsFormRef?.current?.setFieldValue(
        'item_type',
        selectedPriceListType?.id
      )
      setSelectedCategory(selectedPriceListType?.category)
      setSelectedPriceListTypeData(selectedPriceListType?.id)
      setPriceListTypesForOrderItems(selectedPriceListType?.id)
    } else if (
      !selectedData &&
      priceListTypes?.length > 0 &&
      !values?.item_type
    ) {
      const firstOption = priceListTypes[0]?.item
      itemsFormRef?.current?.setFieldValue('item_type', firstOption?.id)
      setPriceListTypesForOrderItems(firstOption?.id)
      setSelectedCategory(firstOption?.category)
      setSelectedPriceListTypeData(firstOption?.id)
    }
  }, [priceListTypes])

  const handleItemCategoryFormChange = (
    newCategory,
    formSetFieldValue,
    formValues
  ) => {
    if (isCashPatient) {
      toast.error(t('Cannot change item category on a cash visit.'))
      return
    }
    formSetFieldValue('item_category', newCategory)
    const isInsurance = newCategory?.toLowerCase() === 'insurance'
    const isSaudiPatient =
      selectedPatientData?.nationality?.toLowerCase() === 'saudi'
    const planPatientShare =
      selectedPatientData?.selected_plan?.patient_share ??
      selectedPatientData?.insurance_plans?.[0]?.patient_share
    const updatedShares = recalculateItemShares(
      {
        ...formValues,
        item_category: newCategory,
        payer_id: isInsurance ? insurancePatientId : cashPayerId,
        patient_share: isInsurance
          ? planPatientShare ?? 0
          : 100
      },
      { isSaudiPatient }
    )
    Object.entries(updatedShares).forEach(([field, value]) =>
      formSetFieldValue(field, value)
    )
    formSetFieldValue(
      'payer_id',
      isInsurance ? insurancePatientId : cashPayerId
    )
    const requiresApproval = isInsurance
    formSetFieldValue('is_approval', requiresApproval)
    formSetFieldValue('approval_status', requiresApproval ? 'pending' : 'approved')
    formSetFieldValue('is_approval_sent', false)
    formSetFieldValue('approval_number', '')
    formSetFieldValue('rejection_reason', '')
  }

  const handleSubmit = async (values, { resetForm }) => {
    const {
      medication_selection_reason,
      prescribed_medication,
      prescribed_medication_code,
      days_supply,
      route,
      dosage,
      frequency,
      instructions,
      approved_qty,
      approved_amount,
      approval_status,
      rejection_reason,
      approval_number,
      invoice_no,
      ...rest
    } = values

    const createItem = () => {
      // const {
      //   standard_code = "",
      //   non_standard_code = "",
      //   non_standard_description = "",
      //   standard_description = "",
      //   ...restMain
      // } = itemToStore || { };

      const referralOut = isReferralOut(values) || isReferralOut(itemToStore)
      const isApprovalRequired = !isCashPatient &&
        values?.item_category?.toLowerCase() === 'insurance' &&
        (referralOut || Boolean(values?.is_approval))
      const finalApprovalStatus = isApprovalRequired
        ? approval_status || 'pending'
        : 'approved'
      const itemSource = values?.source || ''
      const supergitMasterCode =
        values?.supergit_master_code ||
        values?.master_code ||
        values?.non_standard_code ||
        ''
      const favoriteItemSource = values?.master_code || supergitMasterCode
      const favoriteSfdaItem = values?.is_sfda
        ? {
            ...(itemToStore || {}),
            public_price:
              itemToStore?.public_price != null
                ? String(itemToStore.public_price)
                : '',
            is_covered: itemToStore?.is_covered || ''
          }
        : null

      const base = {
        ...rest,
        is_referral_out: referralOut,
        is_approval: isApprovalRequired,
        discount_amount: Number(values?.discount_amount),
        quantity: Number(values?.quantity),
        selected_category: selectedCategory,
        source: itemSource,
        manage_costs: values?.manage_costs || [],
        ...(Favorite && {
          is_favorite: true,
          favItem: {
            source: itemSource,
            master_code: favoriteItemSource,
            supergit_master_code: supergitMasterCode,
            ...(favoriteSfdaItem
              ? {
                  sfda: favoriteSfdaItem
                }
              : {}),
            standard_code: values?.standard_code,
            non_standard_code: values?.non_standard_code,
            non_standard_description: values?.non_standard_description,
            standard_description: values?.standard_description,
            ...(selectedCategory === 'medication-codes' && {
              days_supply: Number(days_supply),
              route,
              dosage,
              frequency,
              instructions
            })
          }
        })
      }

      if (
        base?.source === ITEM_SOURCE_SFDA ||
        base?.source === ITEM_SOURCE_PROVIDER_PHARMACY
      ) {
        base.supergit_master_code = supergitMasterCode
      }

      if (selectedCategory === 'medication-codes') {
        Object.assign(base, {
          medication_selection_reason,
          prescribed_medication,
          prescribed_medication_code,
          days_supply: Number(days_supply),
          route,
          dosage,
          frequency,
          instructions
        })
      }

      base.approval_status = finalApprovalStatus

      if (isApprovalRequired || isRcmAssistant) {
        Object.assign(base, {
          approved_qty: Number(approved_qty),
          approved_amount: Number(approved_amount),
          rejection_reason,
          approval_number,
          invoice_no: Number(invoice_no)
        })
      }

      return base
    }

    if (selectedData) {
      const updatedItems = [...parentValues.items]

      if (updatedIndex !== -1) {
        updatedItems[updatedIndex] = createItem()
        setFieldValue('items', updatedItems)
      }

      setUpdatedIndex(-1)
      setOpenItemsModal(false)
    } else {
      const newItemIndex = parentValues.items.length
      setFieldValue('items', [...parentValues.items, createItem()])
      onItemAdded?.()
      if (isDentalItemCategory) {
        onDentalItemAdded?.(newItemIndex)
      }
    }

    resetForm()
    setFavorite(false)
    setItemToStore(null)
    setSelectedPriceListType(null)
    setSelectedData(null)
  }

  return (
    <div
      className={` flex  ${
        selectedData ? 'flex-row' : 'flex-col-reverse'
      } items-start gap-5 justify-center`}
    >
      {!selectedData && !isNahdiPharmacySelected && (
        <div
          style={{
            height: selectedData
              ? sideDivHeight
                ? `${sideDivHeight}px`
                : 'auto'
              : 'auto'
          }}
          className={` ${
            selectedData ? 'w-[30%] lg:w-[40%]' : 'w-full'
          }  flex items-start  ${
            selectedData ? 'border-r pr-4' : 'border-t pt-4'
          } border-gray-300  overflow-y-auto`}
        >
          {loading ? (
            <div className='w-full h-full flex justify-center items-center'>
              <Spinner width='30' height='30' fill='#0070C2' />
            </div>
          ) : (
            <div className='w-full'>
              {/* Search Input */}
              <div className='mb-3'>
                <input
                  type='text'
                  value={favSearch}
                  onChange={e => setFavSearch(e.target.value)}
                  placeholder={t('Search favorites...')}
                  className='w-full px-3 py-1.5 text-sm border border-gray-300 rounded focus:outline-none focus:border-gray-400'
                />
              </div>
              {(() => {
                const fmt = s =>
                  s.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
                const data = FavoriteItems?.data
                if (!data)
                  return <NoDataFound title={t('NoFavoriteItemsFound')} />

                const searchLower = favSearch.toLowerCase().trim()

                const matchesSearch = item => {
                  if (!searchLower) return true
                  const hasSfda = !!(
                    item?.item?.sfda && Object.keys(item?.item?.sfda).length > 0
                  )
                  const tradeName =
                    item?.item?.sfda?.trade_name?.toLowerCase() || ''
                  const registerNumber =
                    item?.item?.sfda?.register_number?.toLowerCase() || ''
                  const nonStdDesc =
                    item?.price_list?.non_standard_description?.toLowerCase() ||
                    ''
                  const nonStdCode =
                    item?.price_list?.non_standard_code?.toLowerCase() || ''
                  const payerCode =
                    item?.price_list?.payer_details?.[0]?.non_standard_code?.toLowerCase() ||
                    ''

                  return (
                    tradeName.includes(searchLower) ||
                    registerNumber.includes(searchLower) ||
                    nonStdDesc.includes(searchLower) ||
                    nonStdCode.includes(searchLower) ||
                    payerCode.includes(searchLower)
                  )
                }

                const sections = []
                const isProviderPharmacyFavorite = item =>
                  item?.item?.source === ITEM_SOURCE_PROVIDER_PHARMACY
                                ;['cash', 'insurance'].forEach(topKey => {
                  const topVal = data[topKey]
                  if (
                    !topVal ||
                    typeof topVal !== 'object' ||
                    Array.isArray(topVal)
                  )
                    return
                  const subGroups = Object.entries(topVal)
                    .map(([k, v]) => ({
                      label: fmt(k),
                      items: Array.isArray(v) ? v.filter(matchesSearch) : []
                    }))
                    .filter(sg => sg.items.length > 0)
                  if (subGroups.length)
                    sections.push({
                      key: topKey,
                      label: topKey === 'cash' ? t('Cash') : t('Insurance'),
                      color:
                        topKey === 'cash'
                          ? 'bg-blue-100 text-blue-700'
                          : 'bg-green-100 text-green-700',
                      subGroups
                    })
                })
                const providerPharmacyFavorites = [
                  ...(Array.isArray(data.provider_pharmacy)
                    ? data.provider_pharmacy
                    : []),
                  ...(Array.isArray(data.sfda)
                    ? data.sfda.filter(isProviderPharmacyFavorite)
                    : [])
                ]
                if (providerPharmacyFavorites.length > 0 && selectedPharmacyProvider == LOCAL_PHARMACY_PROVIDER_CODE) {
                  const filteredProviderPharmacy =
                    providerPharmacyFavorites.filter(matchesSearch)
                  if (filteredProviderPharmacy.length > 0) {
                    sections.push({
                      key: 'provider_pharmacy',
                      label: businessPharmacyLabel || t('Provider Pharmacy'),
                      color: 'bg-amber-100 text-amber-700',
                      subGroups: [
                        { label: null, items: filteredProviderPharmacy }
                      ]
                    })
                  }
                }
                if (Array.isArray(data.sfda) && data.sfda.length > 0) {
                  const filteredSfda = data.sfda
                    .filter(item => !isProviderPharmacyFavorite(item))
                    .filter(
                      item =>
                        !(
                          isInsurancePatient &&
                          item?.item?.sfda?.is_covered?.toLowerCase() === 'cash'
                        )
                    )
                    .filter(matchesSearch)
                  if (filteredSfda.length > 0 && selectedPharmacyProvider !== LOCAL_PHARMACY_PROVIDER_CODE) {
                    sections.push({
                      key: 'sfda',
                      label: 'SFDA',
                      color: 'bg-purple-100 text-purple-700',
                      subGroups: [{ label: null, items: filteredSfda }]
                    })
                  }
                }

                if (sections.length === 0) {
                  const flat = Array.isArray(data)
                    ? data
                    : Object.values(data)
                        .flat()
                        .filter(i => i?.id)
                  const filteredFlat = flat
                    .filter(
                      item =>
                        !(
                          isInsurancePatient &&
                          item?.item?.sfda?.is_covered?.toLowerCase() === 'cash'
                        )
                    )
                    .filter(matchesSearch)
                  if (filteredFlat.length) {
                    sections.push({
                      key: 'all',
                      label: t('Favorites'),
                      color: 'bg-gray-100 text-gray-700',
                      subGroups: [{ label: null, items: filteredFlat }]
                    })
                  }
                }

                if (sections.length === 0 && searchLower) {
                  return (
                    <NoDataFound title={t('No matching favorites found')} />
                  )
                }

                if (sections.length === 0) {
                  return <NoDataFound title={t('NoFavoriteItemsFound')} />
                }
                const renderItem = item => {
                  const hasSfda = !!(
                    item?.item?.sfda && Object.keys(item?.item?.sfda).length > 0
                  )
                  const hasPriceList = !!(
                    item?.price_list && Object.keys(item?.price_list).length > 0
                  )
                  const shouldUseSfda = hasSfda && !hasPriceList
                  const payer = item?.price_list?.payer_details?.[0]
                  const label = hasSfda
                    ? `${item?.item?.sfda?.trade_name} (${
                        item?.item?.sfda?.register_number || t('No Code')
                      })`
                    : `${item?.price_list?.non_standard_description} (${
                        item?.price_list?.non_standard_code ||
                        payer?.non_standard_code ||
                        t('No Code')
                      })`
                  return (
                    <div
                      key={item.id}
                      onClick={() => {
                        if (
                          shouldUseSfda &&
                          isInsurancePatient &&
                          item?.item?.sfda?.is_covered?.toLowerCase() === 'cash'
                        ) {
                          toast.error(
                            t('Cash-covered SFDA items cannot be added for insurance patients.')
                          )
                          return
                        }

                        if (shouldUseSfda) {
                          handleSelectSfdaItem({
                            value: {
                              other: item?.item,
                              value: item?.item?.sfda?.gtin,
                              item: item?.item?.sfda,
                              sfda: hasSfda
                            }
                          })
                        } else {
                          handleSelectSearchedItem({
                            value: {
                              other: item?.item,
                              value: item?.price_list?.id,
                              item: item?.price_list
                            }
                          })
                        }
                      }}
                      title={label}
                      className='relative px-2 py-2 text-xs sm:text-sm text-center cursor-pointer border border-gray-200 rounded bg-white hover:bg-primary hover:text-white hover:border-primary transition-colors duration-150 leading-snug'
                    >
                      {roleData?.practitioner_id && (
                        <FaStar
                          className={`absolute top-1 right-1 text-yellow-400 hover:text-yellow-500 ${
                            unfavoriteLoading
                              ? 'opacity-50 cursor-not-allowed'
                              : 'cursor-pointer'
                          }`}
                          size={11}
                          onClick={e => handleUnfavorite(item.id, e)}
                          title={t('Remove from favorites')}
                        />
                      )}
                      {label}
                    </div>
                  )
                }

                return (
                  <div className='space-y-3'>
                    {sections.map((section, si) => (
                      <div
                        key={si}
                        className='border border-gray-200 overflow-hidden'
                      >
                        <div className='flex items-center gap-2 px-3 py-2 bg-gray-50 border-b border-gray-200'>
                          <span className='text-sm sm:text-base font-bold text-gray-800'>
                            {section.label}
                          </span>
                        </div>
                        <div className='p-3 space-y-3 bg-white'>
                          {section.subGroups.map((sub, i) => (
                            <div key={i}>
                              {sub.label && (
                                <div className='flex items-center gap-1.5 mb-1.5'>
                                  <span className='text-[10px] sm:text-xs font-semibold text-gray-500 uppercase tracking-widest'>
                                    {sub.label}
                                  </span>
                                  <div className='flex-1 h-px bg-gray-100' />
                                </div>
                              )}
                              <div
                                className={`grid gap-1.5 ${
                                  selectedData
                                    ? 'grid-cols-2 lg:grid-cols-3'
                                    : 'grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6'
                                }`}
                              >
                                {sub.items.map(renderItem)}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                )
              })()}
            </div>
          )}
        </div>
      )}
      <div className='w-full' ref={sideDivRef}>
        <div>
          {selectedData && (
            <div className='flex justify-end items-center mb-2'>
              <CustomButton
                type='submit'
                onClick={() => {
                  itemsFormRef?.current?.submitForm()
                }}
                label={t('Update')}
                icon={<FaPlus size={15} className='me-2' />}
                buttonType='primary'
              />
            </div>
          )}
          {!selectedData &&
            (itemsFormRef?.current?.values?.item_type !== 'medication-codes' ? (
              <SearchPriceListField
                isFull={true}
                searchedItem={searchedPriceItem}
                itemsSuggestions={itemsSuggestions}
                setSearchedItem={setSearchedPriceItem}
                loading={itemLoading}
                handleSelectSearchedItem={handleSelectSearchedItem}
                handleSearchItems={handleSearchItems}
                showNeedApproval={!isCashPatient}
              />
            ) : (
              <>
                <SfdaPriceList
                  isFull={true}
                  searchedItem={searchedPriceItem}
                  setSearchedItem={setSearchedPriceItem}
                  loading={itemLoading}
                  handleSelectSearchedItem={handleSelectSfdaItem}
                  handleSearchItems={handleSearchSfdaItems}
                  itemsSuggestions={itemsSuggestions}
                  selectedPharmacyProvider={selectedPharmacyProvider}
                  getIsApproval={itemData => {
                    const department =
                      auth.roleData?.department?.name_en?.toLowerCase() ||
                      visitData?.department?.name_en?.toLowerCase() ||
                      visitData?.practitioner?.department?.name_en?.toLowerCase()
                    const visitPaymentType =
                      visitData?.visit_payment_type?.toLowerCase() ||
                      emrFormData?.visit_payment_type?.toLowerCase()
                    const isInsurance = visitPaymentType === 'insurance'
                    if (isCashPatient || !isInsurance) return false
                    if (itemData?.drug_type?.toLowerCase() === 'milk') return false
                    if (isReferralOut(itemData)) return true
                    const isWorkRelated = values?.work_related === true
                    const drugType = itemData?.drug_type?.toLowerCase()
                    const isDental = department?.includes('dent')
                    if (drugType) {
                      if (
                        drugType === 'generic' ||
                        drugType === 'brand replacable' ||
                        drugType === 'nce'
                      )
                        return isDental
                      if (
                        [
                          'biological',
                          'medical device',
                          'radiopharmaceutical'
                        ].includes(drugType)
                      )
                        return true
                      if (drugType === 'milk') return false
                    }
                    if (coverageBool === false) return true
                    if (coverageBool === true && isWorkRelated) return false
                    if (isDental || department === 'physiotherapy') return true
                    if (!itemData?.drug_type) return false
                    return itemData?.is_approval ?? false
                  }}
                />
              </>
            ))}
        </div>

        <Formik
          innerRef={itemsFormRef}
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, errors, setFieldValue }) =>
            selectedData && (
              <Form>
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-3 gap-y-1 mt-3'>
                  <DropdownField
                    useFormik={false}
                    value={values?.item_category}
                    name='item_category'
                    label={t('Item Category')}
                    options={[
                      { label: t('Cash'), value: 'cash' },
                      { label: t('Insurance'), value: 'insurance' }
                    ]}
                    placeholder={t('Select Item Category')}
                    disabled={
                      isCashPatient ||
                      !(
                        selectedData?.is_approval_sent === true ||
                        selectedData?.is_approval_sent === 'true'
                      )
                    }
                    handleChange={e =>
                      handleItemCategoryFormChange(e?.value, setFieldValue, values)
                    }
                    className='capitalize'
                  />
                  <TextInput
                    placeholder={t('Enter Standard Code')}
                    name='standard_code'
                    label={t('Standard Code')}
                  />

                  <TextInput
                    placeholder={t('Enter non standard code')}
                    name='non_standard_code'
                    label={t('Non Standard Code')}
                  />
                  <TextInput
                    placeholder={t('Enter non standard description')}
                    name='non_standard_description'
                    label={t('Non Standard Description')}
                  />

                  <div className='relative col-span-1'>
                    <DropdownField
                      filter
                      name='body_site'
                      placeholder={t('Select body site')}
                      label={
                        <div className='flex items-center gap-2'>
                          {t('Select Body Site')}
                          {isDentalItemCategory && (
                            <FaTooth
                              className='text-primary cursor-pointer hover:scale-110 transition-transform'
                              onClick={() => setShowDentalModal(true)}
                              title={t('Open Dental Chart')}
                            />
                          )}
                        </div>
                      }
                      options={
                        isDentalItemCategory ? dentalItems : body_siteitems
                      }
                    />

                    {isDentalItemCategory && (
                      <ReusableModal
                        HeaderIcon={FaTooth}
                        isVisible={showDentalModal}
                        onClose={() => setShowDentalModal(false)}
                        title={t('Select Tooth From Chart')}
                        className='w-[95%] max-w-[500px]'
                        position='top'
                      >
                        <div className='flex flex-col items-center justify-center p-2 bg-white rounded-xl'>
                          <div className='w-full overflow-auto flex justify-center'>
                            <DentalSelctedTooth
                              item={{
                                items: values.body_site
                                  ? [{ body_site: values.body_site }]
                                  : []
                              }}
                              onSelect={tooth => {
                                setFieldValue('body_site', tooth)
                                setShowDentalModal(false)
                              }}
                            />
                          </div>
                          {values.body_site && (
                            <div className='mt-4 flex items-center gap-3'>
                              <span className='text-sm font-medium text-gray-500'>
                                {t('Current Selection')}:
                              </span>
                              <span className='px-4 py-1.5 bg-primary text-white text-sm font-bold rounded-full shadow-md'>
                                {values.body_site}
                              </span>
                            </div>
                          )}
                        </div>
                      </ReusableModal>
                    )}
                  </div>
                  <DropdownField
                    name='sub_site'
                    placeholder={t('Select sub site')}
                    label={t('Sub Site')}
                    options={isDentalItemCategory ? dentalSubSites : subSites}
                  />
                  <DatePicker
                    name='service_start_date'
                    placeholder={t('Select service start date')}
                    label={t('Service Start Date')}
                  />
                  <DatePicker
                    name='service_end_date'
                    placeholder={t('Select service end date')}
                    label={t('Service End Date')}
                  />
                  <SwitchInput
                    label={t('Is Package?')}
                    checked={values?.is_package}
                    handleChange={e => {
                      setFieldValue('is_package', e.value)
                    }}
                    parentClass={'justify-between'}
                  />
                  <SwitchInput
                    label={t('Sessions')}
                    checked={values?.session}
                    handleChange={e => {
                      setFieldValue('session', e.value)
                    }}
                    parentClass={'justify-between'}
                  />
                  <SwitchInput
                    label={t('Attachment')}
                    checked={values?.attachment}
                    handleChange={e => {
                      setFieldValue('attachment', e.value)
                    }}
                    parentClass={'justify-between'}
                  />
                  <div className='flex items-center gap-6'>
                    <SwitchInput
                      label={t('Is Approval')}
                      checked={values?.is_approval}
                      disabled
                      handleChange={e => {
                        setFieldValue('is_approval', e.value)
                      }}
                      parentClass={'!mb-0'}
                    />
                    {values?.is_approval === true &&
                      values?.is_approval_sent === true && (
                        <SwitchInput
                          label={t('Resend Approval')}
                          checked={values?.resend_approval || false}
                          handleChange={e => {
                            setFieldValue('resend_approval', e.value)
                          }}
                          parentClass={'!mb-0'}
                        />
                      )}
                  </div>
                </div>
                <div className='grid grid-cols-12 gap-x-3 gap-y-1 '>
                  <MultiSelectField
                    parentClass='col-span-12 lg:col-span-4'
                    name='supporting_info'
                    placeholder={t('Select supporting info')}
                    label={t('Supporting Info')}
                    options={supportingInfoOptions([
                      ...emrFormValues?.supportingInfos,
                      emrFormValues?.chiefComplaints
                    ])}
                  />
                  <MultiSelectField
                    parentClass='col-span-12 lg:col-span-4'
                    name='diagnosis'
                    placeholder={t('Select diagnosis')}
                    label={t('Select Diagnosis')}
                    options={diagnosisOptions(emrFormValues?.diagnosisArray)}
                  />
                  <MultiSelectField
                    parentClass='col-span-12 lg:col-span-4'
                    name='care_teams'
                    placeholder={t('Select care teams')}
                    label={t('Select Care Teams')}
                    options={careTeamsOptions(emrFormValues?.careTeamsArray)}
                  />
                </div>
                {selectedCategory === 'medication-codes' && (
                  <>
                    <div className='col-span-12 w-full h-[1px] bg-gray-300 mt-4'></div>

                    <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-3 gap-y-1 mt-3'>
                      <DropdownField
                        name='medication_selection_reason'
                        placeholder={t('Select Medication Selection Reason')}
                        label={t('Medication Selection Reason')}
                        options={medSelectionReasons}
                      />
                      <AutoCompleteField
                        label={`${t('Select Prescribed Medication')} (${
                          values?.prescribed_medication_code || ''
                        })`}
                        placeholder={t('Search standard code')}
                        name='prescribed_medication'
                        fieldUrl='/v3/RCM/getItemCodes'
                        payload={{
                          type:
                            priceListTypes?.find(
                              data => data?.value == values?.item_type
                            )?.label || ''
                        }}
                        onSelect={event => {
                          setFieldValue(
                            'prescribed_medication',
                            event?.value?.data?.description
                          )
                          setFieldValue(
                            'prescribed_medication_code',
                            event?.value?.data?.code
                          )
                        }}
                        onBlur={e => {
                          if (
                            !e?.target?.value &&
                            values?.prescribed_medication_code
                          ) {
                            setFieldValue(
                              'prescribed_medication',
                              values?.prescribed_medication
                            )
                            setFieldValue(
                              'prescribed_medication_code',
                              values?.prescribed_medication_code
                            )
                          }
                        }}
                        optionsFormat={standardCodeOptions}
                      />
                      <DropdownField
                        label={t('Route')}
                        placeholder={t('Select a route')}
                        options={(routeOptions || []).map(opt => ({
                          ...opt,
                          label:
                            opt.label.split(' - ')[
                              i18n.language === 'ar' ? 1 : 0
                            ]
                        }))}
                        name='route'
                      />
                      <DropdownField
                        label={t('Frequency')}
                        placeholder={t('Select a frequency')}
                        options={(frequencyOptionss || []).map(opt => ({
                          ...opt,
                          label:
                            opt.label.split(' - ')[
                              i18n.language === 'ar' ? 1 : 0
                            ]
                        }))}
                        name='frequency'
                      />
                      <TextInput
                        label={t('Dosage')}
                        placeholder={t('Enter Dosage')}
                        name='dosage'
                      />
                      <TextInput
                        placeholder={t('Days Supply')}
                        name='days_supply'
                        onChange={e => {
                          const value = e.target.value
                          setFieldValue('days_supply', value)
                        }}
                        label={t('Days Supply')}
                        type='number'
                        step='any'
                      />
                    </div>
                  </>
                )}

                <div className='grid grid-cols-1 gap-x-3 gap-y-1 mt-4'>
                  <div className='flex flex-col gap-1 w-full mb-1'>
                    <label
                      htmlFor='instructions'
                      className='input-label flex items-center gap-x-2'
                    >
                      {t('Instructions')}
                    </label>
                    <Field
                      as='textarea'
                      id='instructions'
                      name='instructions'
                      rows={4}
                      placeholder={t('Instructions')}
                      className='input-field min-h-[100px] resize-y'
                    />
                    {errors?.instructions && (
                      <p className='text-sm text-red-500'>
                        {errors.instructions}
                      </p>
                    )}
                  </div>
                  {['laboratory', 'radiology', 'imaging'].includes(
                    selectedCategory?.toLowerCase()
                  ) && (
                    <div className='flex flex-col gap-1 w-full mb-1'>
                      <label
                        htmlFor='clinical_notes'
                        className='input-label flex items-center gap-x-2'
                      >
                        {t('Clinical Notes')}
                      </label>
                      <Field
                        as='textarea'
                        id='clinical_notes'
                        name='clinical_notes'
                        rows={4}
                        placeholder={t('Enter clinical notes')}
                        className='input-field min-h-[100px] resize-y'
                      />
                      {errors?.clinical_notes && (
                        <p className='text-sm text-red-500'>
                          {errors.clinical_notes}
                        </p>
                      )}
                    </div>
                  )}
                </div>
                {(values?.is_approval || isRcmAssistant) && (
                  <>
                    <div className='col-span-12 w-full h-[1px] bg-gray-300 mt-4'></div>
                    <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-3 gap-y-1 mt-3'>
                      <TextInput
                        name='approved_qty'
                        onChange={e => {
                          const val =
                            e.target.value === '' ? '' : Number(e.target.value)
                          if (val > values?.quantity) {
                            toast.error(
                              t(
                                'Approvedquantityshouldbelessorequalthanquantity'
                              )
                            )
                            return
                          }
                          setFieldValue('approved_qty', val)
                        }}
                        placeholder={t('Enter approved quantity')}
                        label={t('Approved Quantity')}
                        type='number'
                        step='any'
                      />
                      <TextInput
                        name='approved_amount'
                        placeholder={t('Enter approved amount')}
                        onChange={e => {
                          const value = e.target.value
                          if (/^\d*\.?\d*$/.test(value)) {
                            setFieldValue('approved_amount', value)
                          }
                        }}
                        label={t('Approved Amount')}
                      />
                      <DropdownField
                        label={t('Approval Status')}
                        options={approvalStatusOptions(t)}
                        placeholder={t('Select Status')}
                        name={`approval_status`}
                        className='!w-fit'
                        onChange={event => {
                          setFieldValue('approval_status', event.value)
                          setFieldValue(
                            'is_approved_manually',
                            String(event.value || '').toLowerCase() ===
                              'approved'
                          )
                        }}
                      />
                      <TextInput
                        name='approval_number'
                        placeholder={t('Enter approval number')}
                        label={t('Approval Number')}
                      />
                      <TextInput
                        name='invoice_no'
                        placeholder={t('Enter invoice number')}
                        label={t('Invoice Number')}
                        type='number'
                      />
                      {values?.approval_status === 'rejected' && (
                        <TextInput
                          name='rejection_reason'
                          placeholder={t('Enter rejection reason')}
                          label={t('Rejection Reason')}
                        />
                      )}
                    </div>
                  </>
                )}

                <div className='col-span-12 w-full h-[1px] bg-gray-300 mt-4'></div>
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-3 gap-y-1 mt-3'>
                  <TextInput
                    placeholder={t('Enter quantity')}
                    disabled={isRcmAssistant || disableEmrUnitPrice}
                    name='quantity'
                    className='!text-lg'
                    label={t('Qty')}
                    onChange={e => {
                      const val =
                        e.target.value === '' ? '' : Number(e.target.value)
                      if (
                        !values?.is_nahdi_pharmacy &&
                        isQuantityOverStock(values, val)
                      ) {
                        showStockLimitToast(toast, values?.stock)
                        return
                      }
                      setFieldValue('quantity', val)
                    }}
                    type='number'
                    step='any'
                  />
                  <TextInput
                    placeholder={t('Number of Sessions')}
                    name='number_of_sessions'
                    className='!text-lg'
                    label={t('Sessions')}
                    onChange={e => {
                      const val =
                        e.target.value === '' ? '' : Number(e.target.value)
                      setFieldValue('number_of_sessions', val)
                      const originalPrice = values?.original_price || 0
                      const sPrice = (
                        val > 0 ? originalPrice / val : originalPrice
                      ).toFixed(2)
                      setFieldValue('unit_price', sPrice)
                    }}
                    type='number'
                    step='any'
                  />
                  {!hideUnitPrice && (
                  <TextInput
                    placeholder={t('Enter unit price')}
                    name='original_price'
                    disabled={isRcmAssistant}
                    onChange={e => {
                      const val =
                        e.target.value === '' ? '' : Number(e.target.value)
                      setFieldValue('original_price', val)
                      const sessions = values?.number_of_sessions || 1
                      const calculatedUnitPrice = (
                        sessions > 1 ? val / sessions : val || 0
                      ).toFixed(2)
                      setFieldValue('unit_price', calculatedUnitPrice)

                    }}
                    className='!text-lg'
                    label={t('U.Price')}
                    type='text'
                  />
                  )}
                  <TextInput
                    placeholder={t('Enter session price')}
                    name='unit_price'
                    readOnly
                    disabled
                    className='!text-lg'
                    label={t('S.Price')}
                    type='text'
                  />
                  <TextInput
                    placeholder={t('Enter discount price')}
                    name='discount_amount'
                    label={t('Disc')}
                    onChange={e => {
                      const val =
                        e.target.value === '' ? '' : Number(e.target.value)
                      setFieldValue('discount_amount', val)
                    }}
                    type='number'
                    step='any'
                    className='!text-lg'
                  />
                  <TextInput
                    placeholder={t('Enter patient share')}
                    name='patient_share'
                    label={t('Pt.Sh (%)')}
                    type='number'
                    step='any'
                    className='!text-lg'
                    readOnly
                  />
                  <TextInput
                    placeholder={t('Enter tax amount')}
                    name='tax_amount'
                    label={t('Tax Amount')}
                    type='number'
                    step='any'
                    className='!text-lg'
                    readOnly
                  />
                </div>
              </Form>
            )
          }
        </Formik>
        <ConfirmationModal
          visible={showUnfavoriteConfirmation}
          setVisible={setShowUnfavoriteConfirmation}
          header={t('Remove Favorite')}
          message={t(
            'Are you sure you want to remove this item from favorites?'
          )}
          onAccept={confirmUnfavorite}
          isLoading={!!unfavoriteLoading}
          acceptLabel={t('Remove')}
          rejectLabel={t('Cancel')}
          Icon={FaStar}
        />
      </div>
    </div>
  )
}

export default EmrOrderItem
